import {
  Activity,
  AlertTriangle,
  Ban,
  BarChart3,
  Bell,
  BrainCircuit,
  Check,
  ChevronDown,
  CircleX,
  CircleDollarSign,
  Clock3,
  CreditCard,
  Download,
  FileCheck2,
  Eye,
  Gauge,
  History,
  LayoutDashboard,
  LockKeyhole,
  LogOut,
  Menu,
  Megaphone,
  Play,
  Power,
  RefreshCw,
  Search,
  Send,
  ServerCog,
  Settings,
  ShieldCheck,
  ShieldAlert,
  TrendingUp,
  Users,
  UserCheck,
  UserCog,
  WalletCards,
  Grid3X3,
  Gift,
  Headphones,
  MessageSquare,
  X,
} from "lucide-react";
import {
  useDeferredValue,
  useEffect,
  useRef,
  useState,
  type FormEvent,
  type ReactNode,
} from "react";
import {
  acknowledgeAlert,
  adminLogin,
  cancelBroadcast,
  cancelSubscription,
  createAdminAccount,
  createBroadcast,
  exportAuditCsv,
  getAdminAccounts,
  getAdminMarketStatus,
  getAdminScanner,
  getAdminReferrals,
  updateAdminReferral,
  getAdminSupportTickets,
  getAdminSupportTicket,
  updateAdminSupportTicket,
  replyAdminSupportTicket,
  runAdminScanner,
  getSupportTemplates,
  getAdminAlerts,
  getAdminMe,
  getAlertSettings,
  getAnalyses,
  getAuditLogs,
  getBacktest,
  getBroadcasts,
  getBroadcastPreview,
  getDashboard,
  getPaymentSettings,
  getRevenue,
  getRiskControls,
  getOperations,
  getPayments,
  getPlatformSettings,
  getStrategyPerformance,
  getUsers,
  getUserDetail,
  grantSubscription,
  openReceipt,
  reviewPayment,
  runOperationsCheck,
  resolveClientError,
  sendBroadcast,
  searchAdmin,
  updateAdminAccount,
  updateAlertSettings,
  updatePaymentSettings,
  updatePlatformSettings,
  updateRiskControls,
  updateUserStatus,
  type AuditLog,
  type AdminAccount,
  type AdminAlert,
  type AdminMe,
  type AdminMarketStatus,
  type AdminScanner,
  type AdminReferrals,
  type AdminSupportTicket,
  type AdminSupportDetail,
  type SupportTemplate,
  type AdminSearchResult,
  type BacktestReport,
  type Analysis,
  type Dashboard as DashboardData,
  type Payment,
  type PaymentSettings,
  type Revenue,
  type RiskControls,
  type Broadcast,
  type OperationsData,
  type PlatformSettings,
  type StrategyPerformance,
  type User,
  type UserDetail,
  adminLogout,
} from "./api";
type View =
  | "dashboard"
  | "risk"
  | "performance"
  | "operations"
  | "analyses"
  | "scanner"
  | "referrals"
  | "support"
  | "revenue"
  | "payments"
  | "users"
  | "broadcasts"
  | "alerts"
  | "team"
  | "audit"
  | "plans"
  | "settings";

const strategyNameUz = (code: string) =>
  (
    ({
      trend_pullback: "Trendga qaytish",
      liquidity_bos: "Likvidlik va struktura yorilishi",
      bos_choch: "Struktura o‘zgarishi",
      fvg_retest: "Narx bo‘shlig‘ini qayta sinash",
      breakout_retest: "Daraja yorilishi va qayta sinash",
      mean_reversion: "O‘rtacha qiymatga qaytish",
      london_opening_range: "London ochilish diapazoni",
      volatility_squeeze: "Volatillik siqilishi",
      donchian_atr_momentum: "Donchian va ATR impulsi",
      divergence_choch: "Divergensiya va struktura o‘zgarishi",
      bank_manipulation: "Bank manipulyatsiyasi · likvidlik tuzog‘i",
      multi_strategy: "Bir nechta strategiya",
    }) as Record<string, string>
  )[code] ?? code.replaceAll("_", " ");

const statusNameUz = (status: string) =>
  (
    ({
      active: "faol",
      blocked: "bloklangan",
      pending: "kutilmoqda",
      approved: "tasdiqlangan",
      rejected: "rad etilgan",
      expired: "muddati tugagan",
      cancelled: "bekor qilingan",
      draft: "qoralama",
      sending: "yuborilmoqda",
      sent: "yuborilgan",
      failed: "xatolik",
      success: "muvaffaqiyatli",
      partial: "qisman bajarilgan",
      running: "bajarilmoqda",
      resolved: "hal qilingan",
      open: "ochiq",
      waiting_user: "foydalanuvchi javobi kutilmoqda",
      watch: "kuzatuvda",
      no_setup: "savdo holati yo‘q",
      signal: "signal",
      healthy: "barqaror",
      degraded: "sustlashgan",
      down: "ishlamayapti",
      qualified: "tasdiqlangan",
      credited: "bonus berilgan",
      flagged: "tekshiruvda",
    }) as Record<string, string>
  )[status] ?? status.replaceAll("_", " ");

const providerNameUz = (provider: string) =>
  (
    ({
      twelve_data: "Twelve Data",
      yahoo_finance: "Yahoo Finance",
      admin_grant: "Admin bergan tarif",
      payment_approval: "To‘lov tasdig‘i",
    }) as Record<string, string>
  )[provider] ?? provider.replaceAll("_", " ");

const categoryNameUz = (category: string) =>
  (
    ({
      payment: "to‘lov",
      analysis: "tahlil",
      subscription: "obuna",
      technical: "texnik muammo",
      other: "boshqa",
      signal: "signal",
      system: "tizim",
    }) as Record<string, string>
  )[category] ?? category.replaceAll("_", " ");

const priorityNameUz = (priority: string) =>
  (
    ({
      low: "past",
      normal: "odatiy",
      high: "yuqori",
      urgent: "shoshilinch",
    }) as Record<string, string>
  )[priority] ?? priority.replaceAll("_", " ");

const directionNameUz = (direction: string) =>
  direction === "BUY"
    ? "SOTIB OLISH"
    : direction === "SELL"
      ? "SOTISH"
      : direction;

const resultNameUz = (result: string) =>
  (
    ({
      win: "yutuq",
      loss: "yo‘qotish",
      breakeven: "zararsiz",
      cancelled: "bekor qilingan",
    }) as Record<string, string>
  )[result.toLowerCase()] ?? result;
export function App() {
  const [authenticated, setAuthenticated] = useState(
      Boolean(sessionStorage.getItem("vektor-admin-token")),
    ),
    [view, setView] = useState<View>("dashboard"),
    [sidebar, setSidebar] = useState(false),
    [me, setMe] = useState<AdminMe | null>(null),
    [searchQuery, setSearchQuery] = useState(""),
    [searchResults, setSearchResults] = useState<AdminSearchResult[]>([]),
    [searchOpen, setSearchOpen] = useState(false),
    [searchLoading, setSearchLoading] = useState(false);
  const searchRef = useRef<HTMLDivElement>(null);
  const deferredSearch = useDeferredValue(searchQuery);
  useEffect(() => {
    if (authenticated)
      void getAdminMe()
        .then(setMe)
        .catch(() => {
          sessionStorage.removeItem("vektor-admin-token");
          setAuthenticated(false);
        });
  }, [authenticated]);
  useEffect(() => {
    if (!authenticated || deferredSearch.trim().length < 2) {
      setSearchResults([]);
      setSearchLoading(false);
      return;
    }
    let active = true;
    setSearchLoading(true);
    void searchAdmin(deferredSearch.trim())
      .then((results) => {
        if (active) setSearchResults(results);
      })
      .catch(() => {
        if (active) setSearchResults([]);
      })
      .finally(() => {
        if (active) setSearchLoading(false);
      });
    return () => {
      active = false;
    };
  }, [authenticated, deferredSearch]);
  useEffect(() => {
    const closeSearch = (event: PointerEvent) => {
      if (!searchRef.current?.contains(event.target as Node))
        setSearchOpen(false);
    };
    document.addEventListener("pointerdown", closeSearch);
    return () => document.removeEventListener("pointerdown", closeSearch);
  }, []);
  useEffect(() => {
    document.getElementById("admin-main")?.focus();
  }, [view]);
  if (!authenticated)
    return (
      <Login
        onLogin={async (u, p) => {
          await adminLogin(u, p);
          setAuthenticated(true);
        }}
      />
    );
  const nav = [
    ["dashboard", "Boshqaruv", LayoutDashboard],
    ["risk", "Xavf nazorati", ShieldAlert],
    ["performance", "Strategiya samarasi", BarChart3],
    ["operations", "Tizim monitoringi", ServerCog],
    ["analyses", "Jonli tahlillar", BrainCircuit],
    ["scanner", "Bozor va skaner", Grid3X3],
    ["referrals", "Tavsiya nazorati", Gift],
    ["support", "Yordam markazi", Headphones],
    ["revenue", "Tushum", WalletCards],
    ["payments", "To‘lovlar", CircleDollarSign],
    ["users", "Foydalanuvchilar", Users],
    ["broadcasts", "Xabarnomalar", Megaphone],
    ["alerts", "Ogohlantirishlar", AlertTriangle],
    ["team", "Admin jamoasi", UserCog],
    ["audit", "Audit tarixi", History],
    ["plans", "Tarif va limitlar", Gauge],
    ["settings", "To‘lov sozlamalari", Settings],
  ] as const;
  const allowed: Record<string, View[]> = {
    owner: nav.map(([id]) => id),
    finance: [
      "dashboard",
      "revenue",
      "payments",
      "referrals",
      "support",
      "settings",
      "alerts",
    ],
    support: [
      "dashboard",
      "users",
      "broadcasts",
      "analyses",
      "scanner",
      "referrals",
      "support",
      "alerts",
    ],
    analyst: [
      "dashboard",
      "risk",
      "performance",
      "operations",
      "analyses",
      "scanner",
      "plans",
      "alerts",
    ],
  };
  const visibleNav = nav.filter(([id]) =>
    (allowed[me?.role ?? "owner"] ?? allowed.owner!).includes(id),
  );
  return (
    <div className="admin-shell">
      <a className="skip-link" href="#admin-main">
        Asosiy kontentga o‘tish
      </a>
      <aside className={sidebar ? "open" : ""}>
        <div className="admin-brand">
          <span>V</span>
          <div>
            <strong>VEKTOR</strong>
            <small>BOSHQARUV MARKAZI</small>
          </div>
          <button
            onClick={() => setSidebar(false)}
            aria-label="Navigatsiyani yopish"
          >
            <X size={18} />
          </button>
        </div>
        <nav>
          {visibleNav.map(([id, label, Icon]) => (
            <button
              key={id}
              className={view === id ? "active" : ""}
              onClick={() => {
                setView(id);
                setSidebar(false);
              }}
            >
              <Icon size={19} />
              <span>{label}</span>
            </button>
          ))}
        </nav>
        <div className="aside-foot">
          <div className="system-secure">
            <ShieldCheck size={16} />
            <span>Ishlab turgan tizim himoyalangan</span>
          </div>
          <button
            onClick={() => {
              void adminLogout();
              setAuthenticated(false);
            }}
          >
            <LogOut size={19} />
            Chiqish
          </button>
        </div>
      </aside>
      <div className="admin-content">
        <header>
          <button
            className="menu-button"
            onClick={() => setSidebar(true)}
            aria-label="Navigatsiyani ochish"
          >
            <Menu size={20} />
          </button>
          <div className="global-search" ref={searchRef}>
            <Search size={18} />
            <input
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                setSearchOpen(true);
              }}
              onFocus={() => setSearchOpen(true)}
              onKeyDown={(e) => {
                if (e.key === "Escape") setSearchOpen(false);
              }}
              placeholder="User, to‘lov yoki tahlil qidirish..."
              aria-label="Global qidiruv"
              aria-expanded={searchOpen && searchQuery.length >= 2}
              aria-controls="admin-search-results"
            />
            {searchOpen && searchQuery.trim().length >= 2 && (
              <div
                className="search-results"
                id="admin-search-results"
                role="listbox"
              >
                {searchLoading ? (
                  <p aria-live="polite">
                    <RefreshCw size={16} className="spin" />
                    Qidirilmoqda...
                  </p>
                ) : searchResults.length ? (
                  searchResults.map((result) => (
                    <button
                      key={`${result.type}-${result.id}`}
                      onClick={() => {
                        setView(result.target);
                        setSearchOpen(false);
                        setSearchQuery("");
                      }}
                      role="option"
                    >
                      <span className={`search-type ${result.type}`}>
                        {result.type.slice(0, 1).toUpperCase()}
                      </span>
                      <div>
                        <strong>{result.title}</strong>
                        <small>{result.subtitle}</small>
                      </div>
                    </button>
                  ))
                ) : (
                  <p>
                    <Search size={16} />
                    Natija topilmadi. Login, Telegram ID yoki aktiv nomini
                    tekshiring.
                  </p>
                )}
              </div>
            )}
          </div>
          <button
            className="header-icon"
            onClick={() => setView("alerts")}
            aria-label="Ogohlantirishlar"
          >
            <Bell size={19} />
            <i />
          </button>
          <div className="admin-user">
            <span>AD</span>
            <div>
              <strong>{me?.username ?? "Administrator"}</strong>
              <small>{me?.role ?? "owner"}</small>
            </div>
            <ChevronDown size={16} />
          </div>
        </header>
        <main id="admin-main" tabIndex={-1}>
          {view === "dashboard" && <Dashboard />}
          {view === "risk" && <RiskControlView />}
          {view === "performance" && <StrategyPerformanceView />}
          {view === "operations" && <OperationsView />}
          {view === "analyses" && <Analyses />}
          {view === "scanner" && <MarketScannerView />}
          {view === "referrals" && <ReferralsView />}
          {view === "support" && <SupportOpsView />}
          {view === "revenue" && <RevenueView />}
          {view === "payments" && <Payments />}
          {view === "users" && (
            <UsersView canManageSubscriptions={me?.role === "owner"} />
          )}
          {view === "broadcasts" && <BroadcastView />}
          {view === "alerts" && <AlertsView owner={me?.role === "owner"} />}
          {view === "team" && <TeamView />}
          {view === "audit" && <AuditView />}
          {view === "plans" && <PlanSettings />}
          {view === "settings" && <PaymentSettingsView />}
        </main>
      </div>
      {sidebar && (
        <button
          className="sidebar-scrim"
          onClick={() => setSidebar(false)}
          aria-label="Navigatsiyani yopish"
        />
      )}
    </div>
  );
}
function Login({
  onLogin,
}: {
  onLogin: (u: string, p: string) => Promise<void>;
}) {
  const [loading, setLoading] = useState(false),
    [error, setError] = useState("");
  const submit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const data = new FormData(e.currentTarget);
    try {
      await onLogin(String(data.get("username")), String(data.get("password")));
    } catch (reason) {
      setError(
        reason instanceof Error ? reason.message : "Kirish amalga oshmadi",
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="login-page">
      <div className="login-visual">
        <div className="login-brand">
          <span>V</span>
          <div>
            <strong>VEKTOR</strong>
            <small>MARKETS</small>
          </div>
        </div>
        <div>
          <p>AI SAVDO BOSHQARUVI</p>
          <h1>
            Bozor nazorati.
            <br />
            <em>Yangi darajada.</em>
          </h1>
          <span>
            Tahlillar, tariflar, foydalanuvchilar va to‘lovlar — yagona premium
            boshqaruv markazida.
          </span>
        </div>
        <footer>Cloudflare infratuzilmasi · D1 · R2 · AI</footer>
      </div>
      <div className="login-panel">
        <form onSubmit={submit}>
          <span className="login-lock">
            <LockKeyhole size={22} />
          </span>
          <p className="eyebrow">ADMIN BOSHQARUV MARKAZI</p>
          <h2>Xush kelibsiz</h2>
          <p className="muted">
            Davom etish uchun administrator hisobiga kiring.
          </p>
          <label>
            Login
            <input required name="username" autoComplete="username" />
          </label>
          <label>
            Parol
            <input
              required
              minLength={7}
              name="password"
              type="password"
              autoComplete="current-password"
            />
          </label>
          {error && <p className="login-error">{error}</p>}
          <button className="primary" disabled={loading}>
            {loading ? "Tekshirilmoqda..." : "Kirish"}
          </button>
          <small className="security-note">
            <ShieldCheck size={14} />
            Sessiya himoyalangan
          </small>
        </form>
      </div>
    </div>
  );
}
function PageTitle({
  eyebrow,
  title,
  subtitle,
  action,
}: {
  eyebrow: string;
  title: string;
  subtitle: string;
  action?: ReactNode;
}) {
  return (
    <div className="content-title">
      <div>
        <p className="eyebrow">{eyebrow}</p>
        <h1>{title}</h1>
        <p>{subtitle}</p>
      </div>
      {action}
    </div>
  );
}
function Dashboard() {
  const [data, setData] = useState<DashboardData | null>(null),
    [error, setError] = useState("");
  const load = () =>
    getDashboard()
      .then(setData)
      .catch((e) => setError(e.message));
  useEffect(() => {
    void load();
  }, []);
  return (
    <>
      <PageTitle
        eyebrow="JONLI PLATFORMA KO‘RINISHI"
        title="Boshqaruv markazi"
        subtitle="Haqiqiy tizim holati, tahlil oqimi va obunalar."
        action={
          <button className="secondary" onClick={load}>
            <RefreshCw size={16} />
            Yangilash
          </button>
        }
      />
      {error && <p className="admin-error">{error}</p>}
      <section className="admin-stats">
        <Stat icon={<Users />} label="Foydalanuvchilar" value={data?.users} />
        <Stat
          icon={<CreditCard />}
          label="Faol obunalar"
          value={data?.activeSubscriptions}
        />
        <Stat
          icon={<BrainCircuit />}
          label="Oylik tahlillar"
          value={data?.monthlyAnalyses}
        />
        <Stat
          icon={<Activity />}
          label="Jonli signallar"
          value={data?.liveSignals}
        />
      </section>
      <div className="dashboard-grid">
        <section className="admin-card system-card">
          <div className="card-heading">
            <div>
              <h2>Infratuzilma</h2>
              <p>Ishlab turgan provayder holati</p>
            </div>
          </div>
          <Status
            name="Bozor OHLC · avtomatik zaxira"
            ok={Boolean(data?.marketProviderConfigured)}
          />
          <Status
            name="Cloudflare Workers AI"
            ok={Boolean(data?.aiConfigured)}
          />
          <Status name="D1 ma’lumotlar bazasi" ok />
          <Status name="R2 chek saqlash tizimi" ok />
        </section>
        <section className="admin-card">
          <div className="card-heading">
            <div>
              <h2>Obuna portfeli</h2>
              <p>Faol tariflar kesimi</p>
            </div>
          </div>
          <div className="plan-bars">
            {["TRIAL", "PRO", "ELITE"].map((code) => {
              const count = Number(
                data?.plans.find((p) => p.code === code)?.count ?? 0,
              );
              return (
                <div key={code}>
                  <span>{code}</span>
                  <i>
                    <b style={{ width: `${Math.min(100, count * 8)}%` }} />
                  </i>
                  <strong>{count}</strong>
                </div>
              );
            })}
          </div>
          <div className="pending-callout">
            <Clock3 size={18} />
            <div>
              <strong>{data?.pendingPayments ?? 0} ta chek tekshiruvda</strong>
              <small>To‘lovlar bo‘limidan boshqaring</small>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
function StrategyPerformanceView() {
  const [period, setPeriod] = useState<30 | 90 | 365>(90),
    [data, setData] = useState<StrategyPerformance | null>(null),
    [loading, setLoading] = useState(true),
    [error, setError] = useState("");
  const load = (days = period) => {
    setLoading(true);
    setError("");
    getStrategyPerformance(days)
      .then(setData)
      .catch((reason) =>
        setError(
          reason instanceof Error ? reason.message : "Ma’lumot yuklanmadi",
        ),
      )
      .finally(() => setLoading(false));
  };
  useEffect(() => {
    void load(period);
  }, [period]);
  const summary = data?.summary;
  return (
    <>
      <PageTitle
        eyebrow="TEKSHIRILGAN SIGNAL NATIJALARI"
        title="Strategiya samarasi"
        subtitle="Faqat haqiqiy yopilgan signallar asosidagi yutuq ulushi va R natijalari. Ochiq signallar hisobga kiritilmaydi."
        action={
          <button
            className="secondary"
            onClick={() => load()}
            disabled={loading}
          >
            <RefreshCw size={16} className={loading ? "spin" : ""} />
            Yangilash
          </button>
        }
      />
      <div className="performance-toolbar" aria-label="Hisobot davri">
        <div role="group" aria-label="Davrni tanlash">
          {([30, 90, 365] as const).map((days) => (
            <button
              key={days}
              className={period === days ? "active" : ""}
              aria-pressed={period === days}
              onClick={() => setPeriod(days)}
            >
              {days === 365 ? "1 yil" : `${days} kun`}
            </button>
          ))}
        </div>
        <span>
          {data
            ? `${formatAdminDate(data.since)} dan boshlab`
            : "Ishlab turgan D1 bazasi"}
        </span>
      </div>
      {error && <p className="admin-error">{error}</p>}
      <section className="performance-stats" aria-busy={loading}>
        <PerformanceMetric
          icon={<BarChart3 />}
          label="Jami signallar"
          value={summary?.totalSignals}
          hint={`${summary?.openSignals ?? 0} ta ochiq`}
        />
        <PerformanceMetric
          icon={<TrendingUp />}
          label="Tasdiqlangan muvaffaqiyat ulushi"
          value={
            summary?.winRate === null || summary?.winRate === undefined
              ? "—"
              : `${summary.winRate}%`
          }
          hint={`${summary?.closedSignals ?? 0} ta yopilgan`}
        />
        <PerformanceMetric
          icon={<Check />}
          label="Yutuq / yo‘qotish"
          value={summary ? `${summary.wins} / ${summary.losses}` : undefined}
          hint={`${summary?.breakeven ?? 0} ta zararsiz yopilgan`}
        />
        <PerformanceMetric
          icon={<Activity />}
          label="O‘rtacha natija"
          value={
            summary
              ? `${summary.avgR > 0 ? "+" : ""}${summary.avgR}R`
              : undefined
          }
          hint="Yopilgan signal bo‘yicha"
        />
      </section>
      <section className="daily-performance-card" aria-busy={loading}>
        <div className="card-heading">
          <div>
            <h2>Kunlik signal statistikasi</h2>
            <p>Signal e’lon qilingan kun bo‘yicha yakuniy natija · UTC+5</p>
          </div>
        </div>
        {data?.dailySignals.length ? (
          <div className="daily-performance-table">
            <div className="daily-performance-head">
              <span>Sana</span>
              <span>Jami</span>
              <span>TP</span>
              <span>SL</span>
              <span>Zararsiz</span>
              <span>Kutilmoqda</span>
              <span>Muddati tugagan</span>
            </div>
            {data.dailySignals.slice(0, 14).map((day) => (
              <div className="daily-performance-row" key={day.day}>
                <time dateTime={day.day}>
                  {new Date(`${day.day}T00:00:00+05:00`).toLocaleDateString(
                    "uz-UZ",
                    { day: "2-digit", month: "short", year: "numeric" },
                  )}
                </time>
                <strong>{day.total}</strong>
                <b className="daily-tp">{day.tp}</b>
                <b className="daily-sl">{day.sl}</b>
                <b className="daily-breakeven">{day.breakeven}</b>
                <b>{day.pending}</b>
                <b>{day.expired}</b>
              </div>
            ))}
          </div>
        ) : (
          <p className="performance-empty">
            Tanlangan davrda avtomatik signal berilmagan.
          </p>
        )}
      </section>
      <BacktestPanel />
      <section className="strategy-grid" aria-label="Strategiyalar kesimi">
        {loading && !data ? (
          <p className="performance-empty">
            Strategiya natijalari yuklanmoqda…
          </p>
        ) : (
          data?.strategies.map((strategy) => {
            const hasSample = strategy.winRate !== null;
            return (
              <article className="strategy-performance-card" key={strategy.id}>
                <div className="strategy-card-head">
                  <div>
                    <span>{strategyNameUz(strategy.code)}</span>
                    <h2>{strategy.nameUz}</h2>
                  </div>
                  <i className={strategy.active ? "active" : ""}>
                    {strategy.active ? "FAOL" : "O‘CHIQ"}
                  </i>
                </div>
                <div className="winrate-line">
                  <strong>{hasSample ? `${strategy.winRate}%` : "—"}</strong>
                  <span>
                    {hasSample
                      ? `${strategy.wins} ta yutuq · ${strategy.losses} ta yo‘qotish`
                      : "Yopilgan signal yetarli emas"}
                  </span>
                </div>
                <div
                  className="winrate-track"
                  role="progressbar"
                  aria-label={`${strategy.nameUz} muvaffaqiyat ulushi`}
                  aria-valuemin={0}
                  aria-valuemax={100}
                  aria-valuenow={strategy.winRate ?? 0}
                  aria-valuetext={
                    hasSample ? `${strategy.winRate} foiz` : "Ma’lumot yo‘q"
                  }
                >
                  <b style={{ width: `${strategy.winRate ?? 0}%` }} />
                  <em style={{ left: "60%" }} />
                </div>
                <dl>
                  <div>
                    <dt>Signal</dt>
                    <dd>{strategy.totalSignals}</dd>
                  </div>
                  <div>
                    <dt>Yopilgan</dt>
                    <dd>{strategy.closedSignals}</dd>
                  </div>
                  <div>
                    <dt>O‘rtacha R</dt>
                    <dd>
                      {strategy.avgR > 0 ? "+" : ""}
                      {strategy.avgR}
                    </dd>
                  </div>
                  <div>
                    <dt>Ishonch</dt>
                    <dd>{strategy.avgConfidence}%</dd>
                  </div>
                </dl>
              </article>
            );
          })
        )}
      </section>
      <section className="performance-results">
        <div className="card-heading">
          <h2>Oxirgi yopilgan signallar</h2>
          <p>Kuzatuv tizimi hisoblagan tekshirilgan natijalar</p>
        </div>
        {data?.recentResults.length ? (
          <DataTable
            headers={["Strategiya", "Bozor", "Natija", "R", "Yopilgan vaqt"]}
          >
            {data.recentResults.map((result) => (
              <tr key={result.id}>
                <td>
                  <strong>
                    {result.strategyCode
                      ? strategyNameUz(result.strategyCode)
                      : "Bir nechta strategiya"}
                  </strong>
                </td>
                <td>
                  <strong>{result.symbol}</strong>
                  <small>{result.timeframe}</small>
                </td>
                <td>
                  <span className={`status ${result.resultType}`}>
                    {resultNameUz(result.resultType)}
                  </span>
                </td>
                <td>
                  <strong
                    className={
                      result.realizedR > 0
                        ? "positive-value"
                        : result.realizedR < 0
                          ? "negative-value"
                          : ""
                    }
                  >
                    {result.realizedR > 0 ? "+" : ""}
                    {result.realizedR}R
                  </strong>
                </td>
                <td>{formatAdminDate(result.closedAt)}</td>
              </tr>
            ))}
          </DataTable>
        ) : (
          <p className="performance-empty">
            Tanlangan davrda yopilgan signal yo‘q. Muvaffaqiyat ulushi signal
            yopilgandan keyin avtomatik hisoblanadi.
          </p>
        )}
      </section>
    </>
  );
}
function BacktestPanel() {
  const [symbol, setSymbol] = useState("XAUUSD"),
    [timeframe, setTimeframe] = useState("M15"),
    [strategy, setStrategy] = useState("trend_pullback"),
    [report, setReport] = useState<BacktestReport | null>(null),
    [loading, setLoading] = useState(false),
    [error, setError] = useState("");
  const run = () => {
    setLoading(true);
    setError("");
    getBacktest(symbol, timeframe, strategy)
      .then(setReport)
      .catch((reason) =>
        setError(
          reason instanceof Error
            ? reason.message
            : "Tarixiy sinov bajarilmadi",
        ),
      )
      .finally(() => setLoading(false));
  };
  return (
    <section className="backtest-panel" aria-busy={loading}>
      <div className="card-heading">
        <div>
          <h2>Tarixiy bosqichma-bosqich sinov</h2>
          <p>Har signal faqat o‘sha paytgacha mavjud OHLC bilan hisoblanadi</p>
        </div>
      </div>
      <div className="backtest-controls">
        <label>
          Bozor
          <select
            value={symbol}
            onChange={(event) => setSymbol(event.target.value)}
          >
            <option>XAUUSD</option>
            <option>EURUSD</option>
            <option>GBPUSD</option>
            <option>USDJPY</option>
            <option>AUDUSD</option>
            <option>USDCAD</option>
            <option>USDCHF</option>
            <option>NZDUSD</option>
          </select>
        </label>
        <label>
          Vaqt oralig‘i
          <select
            value={timeframe}
            onChange={(event) => setTimeframe(event.target.value)}
          >
            <option>M5</option>
            <option>M15</option>
            <option>M30</option>
            <option>H1</option>
            <option>H4</option>
          </select>
        </label>
        <label>
          Strategiya
          <select
            value={strategy}
            onChange={(event) => setStrategy(event.target.value)}
          >
            <option value="trend_pullback">Trendga qaytish</option>
            <option value="liquidity_bos">
              Likvidlik va struktura yorilishi
            </option>
            <option value="bos_choch">Struktura o‘zgarishi</option>
            <option value="fvg_retest">Narx bo‘shlig‘ini qayta sinash</option>
            <option value="breakout_retest">
              Daraja yorilishi va qayta sinash
            </option>
            <option value="mean_reversion">O‘rtacha qiymatga qaytish</option>
            <option value="london_opening_range">
              London ochilish diapazoni
            </option>
            <option value="volatility_squeeze">Volatillik siqilishi</option>
            <option value="donchian_atr_momentum">
              Donchian + ATR impulsi
            </option>
            <option value="divergence_choch">
              Divergensiya va struktura o‘zgarishi
            </option>
            <option value="bank_manipulation">
              Bank manipulyatsiyasi · likvidlik tuzog‘i
            </option>
          </select>
        </label>
        <button className="primary" onClick={run} disabled={loading}>
          <Play size={16} />
          {loading ? "Hisoblanmoqda…" : "Tarixiy sinovni boshlash"}
        </button>
      </div>
      {error && <p className="admin-error">{error}</p>}
      {report && (
        <>
          <div className="backtest-metrics">
            <div>
              <span>Yutuq ulushi</span>
              <strong>
                {report.winRate === null ? "—" : `${report.winRate}%`}
              </strong>
            </div>
            <div>
              <span>Bitimlar</span>
              <strong>{report.trades}</strong>
            </div>
            <div>
              <span>Sof natija</span>
              <strong
                className={
                  report.netR >= 0 ? "positive-value" : "negative-value"
                }
              >
                {report.netR > 0 ? "+" : ""}
                {report.netR}R
              </strong>
            </div>
            <div>
              <span>Kutiladigan natija</span>
              <strong>{report.expectancyR}R</strong>
            </div>
            <div>
              <span>Foyda koeffitsiyenti</span>
              <strong>{report.profitFactor ?? "∞"}</strong>
            </div>
            <div>
              <span>Eng katta pasayish</span>
              <strong>{report.maxDrawdownR}R</strong>
            </div>
          </div>
          <p className="backtest-warning">
            {report.warningUz} Namuna: {report.sampleCandles} ta sham ·{" "}
            {providerNameUz(report.provider)}.
          </p>
        </>
      )}
    </section>
  );
}
function OperationsView() {
  const [data, setData] = useState<OperationsData | null>(null),
    [loading, setLoading] = useState(true),
    [running, setRunning] = useState(false),
    [resolving, setResolving] = useState(""),
    [error, setError] = useState("");
  const load = () => {
    setLoading(true);
    setError("");
    return getOperations()
      .then(setData)
      .catch((reason) =>
        setError(
          reason instanceof Error ? reason.message : "Monitoring yuklanmadi",
        ),
      )
      .finally(() => setLoading(false));
  };
  useEffect(() => {
    void load();
  }, []);
  const runNow = async () => {
    setRunning(true);
    setError("");
    try {
      await runOperationsCheck();
      await load();
    } catch (reason) {
      setError(
        reason instanceof Error ? reason.message : "Tekshiruv ishga tushmadi",
      );
    } finally {
      setRunning(false);
    }
  };
  const resolveError = async (id: string) => {
    setResolving(id);
    setError("");
    try {
      await resolveClientError(id);
      await load();
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : "Xato yopilmadi");
    } finally {
      setResolving("");
    }
  };
  const latest = data?.runs[0],
    health = data?.health;
  const healthLabel = !health
    ? "Tekshirilmoqda"
    : health.status === "success"
      ? "Tizim ishlayapti"
      : health.status === "running"
        ? "Tekshiruv ishlayapti"
        : health.status === "partial"
          ? "Qisman xato aniqlandi"
          : health.status === "failed"
            ? "Cron ishlamadi"
            : "Cron kechikmoqda";
  const stateTotal =
    data?.signalStates.reduce((sum, item) => sum + Number(item.count), 0) ?? 0;
  return (
    <>
      <PageTitle
        eyebrow="AVTOMATLASHTIRISH VA SIGNAL BOSQICHLARI"
        title="Tizim monitoringi"
        subtitle="5 daqiqalik avtomatik vazifa, skaner va signal kuzatuvchisi holatini D1 yozuvlari orqali kuzatish."
        action={
          <button
            className="primary"
            onClick={runNow}
            disabled={running || loading}
          >
            {running ? (
              <RefreshCw size={16} className="spin" />
            ) : (
              <Play size={16} />
            )}{" "}
            {running ? "Tekshirilmoqda…" : "Hozir tekshirish"}
          </button>
        }
      />
      {error && (
        <p className="admin-error" role="alert">
          {error} Qayta urinib ko‘ring.
        </p>
      )}
      <section
        className={`operations-health ${health?.status ?? "unknown"}`}
        aria-live="polite"
      >
        <span>
          {health?.status === "success" ? (
            <ShieldCheck />
          ) : health?.status === "running" ? (
            <RefreshCw className="spin" />
          ) : (
            <Clock3 />
          )}
        </span>
        <div>
          <p>AVTOMATIK VAZIFALAR HOLATI</p>
          <h2>{healthLabel}</h2>
          <small>
            {health?.latestStartedAt
              ? `Oxirgi ishga tushish: ${formatAdminDate(health.latestStartedAt)}`
              : "Birinchi monitoring yozuvi kutilmoqda"}
          </small>
        </div>
        <strong>Har {health?.expectedEveryMinutes ?? 15} daqiqa</strong>
      </section>
      <section className="operations-stats">
        <PerformanceMetric
          icon={<Activity />}
          label="Tekshirilgan signallar"
          value={latest?.trackedSignals}
          hint={`${latest?.activatedSignals ?? 0} ta aktivlashtirildi`}
        />
        <PerformanceMetric
          icon={<BarChart3 />}
          label="Yangi signallar"
          value={latest?.createdSignals}
          hint={`${latest?.expiredSignals ?? 0} ta muddati tugagan`}
        />
        <PerformanceMetric
          icon={<Check />}
          label="Yopilgan signallar"
          value={latest?.closedSignals}
          hint="Kuzatuv natijasi"
        />
        <PerformanceMetric
          icon={<Clock3 />}
          label="Cron davomiyligi"
          value={
            latest?.durationMs == null
              ? undefined
              : formatDuration(latest.durationMs)
          }
          hint={`${latest?.errorCount ?? 0} ta xato`}
        />
      </section>
      <div className="operations-grid">
        <section className="admin-card">
          <div className="card-heading">
            <h2>Signal bosqichlari</h2>
            <p>Barcha avtomatik signallar holati</p>
          </div>
          <div className="lifecycle-bars">
            {data?.signalStates.length ? (
              data.signalStates.map((item) => (
                <div key={item.status}>
                  <span>
                    <b>{statusNameUz(item.status)}</b>
                    <strong>{item.count}</strong>
                  </span>
                  <i>
                    <em
                      className={item.status}
                      style={{
                        width: `${stateTotal ? Math.max(4, (Number(item.count) / stateTotal) * 100) : 0}%`,
                      }}
                    />
                  </i>
                </div>
              ))
            ) : (
              <p className="monitor-empty">
                Avtomatik signal hali yaratilmagan
              </p>
            )}
          </div>
        </section>
        <section className="admin-card">
          <div className="card-heading">
            <h2>24 soatlik hodisalar</h2>
            <p>Kuzatuvchi yaratgan signal hodisalari</p>
          </div>
          <div className="event-count-grid">
            {data?.eventCounts24h.length ? (
              data.eventCounts24h.map((item) => (
                <article key={item.eventType}>
                  <span>{eventLabel(item.eventType)}</span>
                  <strong>{item.count}</strong>
                  <small>{item.eventType}</small>
                </article>
              ))
            ) : (
              <p className="monitor-empty">Oxirgi 24 soatda hodisa yo‘q</p>
            )}
          </div>
        </section>
      </div>
      <section className="provider-health-card">
        <div className="card-heading">
          <h2>Provayder holati · 24 soat</h2>
          <p>Kechikish, xatolar va zaxira manbaga o‘tish statistikasi</p>
        </div>
        <div className="provider-health-grid">
          {data?.providerStats24h.length ? (
            data.providerStats24h.map((provider) => {
              const errorRate = provider.requests
                ? Math.round((provider.errors / provider.requests) * 1000) / 10
                : 0;
              const latencyScore = Math.min(100, provider.avgLatencyMs / 30);
              return (
                <article key={provider.provider}>
                  <div>
                    <strong>{providerNameUz(provider.provider)}</strong>
                    <span
                      className={
                        provider.errors
                          ? "provider-state warning"
                          : "provider-state healthy"
                      }
                    >
                      {provider.errors ? "XATO BOR" : "BARQAROR"}
                    </span>
                  </div>
                  <dl>
                    <div>
                      <dt>So‘rov</dt>
                      <dd>{provider.requests}</dd>
                    </div>
                    <div>
                      <dt>O‘rtacha kechikish</dt>
                      <dd>{provider.avgLatencyMs} ms</dd>
                    </div>
                    <div>
                      <dt>Xatolar ulushi</dt>
                      <dd>{errorRate}%</dd>
                    </div>
                    <div>
                      <dt>Zaxira manbaga o‘tish</dt>
                      <dd>{provider.failovers}</dd>
                    </div>
                  </dl>
                  <div
                    className="provider-latency"
                    role="progressbar"
                    aria-label={`${providerNameUz(provider.provider)} kechikishi`}
                    aria-valuemin={0}
                    aria-valuemax={3000}
                    aria-valuenow={provider.avgLatencyMs}
                    aria-valuetext={`${provider.avgLatencyMs} millisekund`}
                  >
                    <b style={{ width: `${latencyScore}%` }} />
                    <em style={{ left: "50%" }} />
                  </div>
                  <small>Me’yor: 1500 ms</small>
                </article>
              );
            })
          ) : (
            <p className="monitor-empty">
              Yangi telemetriya migratsiyasidan keyingi provayder so‘rovlari
              kutilmoqda.
            </p>
          )}
        </div>
      </section>
      <section className="performance-results">
        <div className="card-heading">
          <h2>Interfeys xatolari · 24 soat</h2>
          <p>
            {data?.clientErrors24h.unresolved ?? 0} ta ochiq xato turi ·{" "}
            {data?.clientErrors24h.occurrences ?? 0} ta hodisa
          </p>
        </div>
        {data?.recentClientErrors.length ? (
          <DataTable
            headers={[
              "Ilova",
              "Yo‘nalish",
              "Xato",
              "Takror",
              "Oxirgi",
              "Holat",
            ]}
          >
            {data.recentClientErrors.map((item) => (
              <tr key={item.id}>
                <td>
                  <span className="plan-badge">{item.app}</span>
                </td>
                <td>
                  <code>{item.route}</code>
                </td>
                <td>
                  <strong>{item.message}</strong>
                  <small>Birinchi: {formatAdminDate(item.firstSeenAt)}</small>
                </td>
                <td>{item.occurrenceCount}</td>
                <td>{formatAdminDate(item.lastSeenAt)}</td>
                <td>
                  {item.resolvedAt ? (
                    <span className="status approved">yopilgan</span>
                  ) : (
                    <button
                      className="secondary"
                      disabled={resolving === item.id}
                      onClick={() => void resolveError(item.id)}
                    >
                      <Check size={15} />
                      {resolving === item.id ? "Yopilmoqda…" : "Yopish"}
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </DataTable>
        ) : (
          <p className="performance-empty">Interfeys xatosi qayd etilmagan.</p>
        )}
      </section>
      <section className="cron-history">
        <div className="card-heading">
          <h2>Oxirgi avtomatik ishga tushishlar</h2>
          <p>Holat, davomiylik va bajarilgan amallar</p>
        </div>
        <div className="cron-run-list">
          {loading && !data ? (
            <p className="monitor-empty">Monitoring yuklanmoqda…</p>
          ) : data?.runs.length ? (
            data.runs.slice(0, 12).map((run) => (
              <article key={run.id}>
                <span className={`run-state ${run.status}`}>
                  {run.status === "success" ? (
                    <Check size={15} />
                  ) : run.status === "running" ? (
                    <RefreshCw size={15} className="spin" />
                  ) : (
                    <Clock3 size={15} />
                  )}{" "}
                  {statusNameUz(run.status)}
                </span>
                <div>
                  <strong>{formatAdminDate(run.startedAt)}</strong>
                  <small>
                    {run.trackedSignals} ta kuzatilgan · {run.createdSignals} ta
                    yaratilgan · {run.closedSignals} ta yopilgan
                  </small>
                  {run.errors.length > 0 && <em>{run.errors[0]}</em>}
                </div>
                <time>
                  {run.durationMs == null
                    ? "—"
                    : formatDuration(run.durationMs)}
                </time>
              </article>
            ))
          ) : (
            <p className="monitor-empty">
              Cron tarixi hali yo‘q. “Hozir tekshirish” orqali birinchi yozuvni
              yarating.
            </p>
          )}
        </div>
      </section>
      <section className="performance-results">
        <div className="card-heading">
          <h2>Oxirgi signal hodisalari</h2>
          <p>Signal bo‘yicha tekshiriladigan audit izi</p>
        </div>
        {data?.recentEvents.length ? (
          <DataTable headers={["Bozor", "Yo‘nalish", "Hodisa", "Narx", "Vaqt"]}>
            {data.recentEvents.map((event) => (
              <tr key={event.id}>
                <td>
                  <strong>{event.symbol}</strong>
                  <small>{event.timeframe}</small>
                </td>
                <td>
                  <span className={`status ${event.direction.toLowerCase()}`}>
                    {directionNameUz(event.direction)}
                  </span>
                </td>
                <td>
                  <strong>{eventLabel(event.eventType)}</strong>
                  <small>
                    {event.targetOrder
                      ? `TP${event.targetOrder}`
                      : event.eventType}
                  </small>
                </td>
                <td>{event.price ?? "—"}</td>
                <td>{formatAdminDate(event.createdAt)}</td>
              </tr>
            ))}
          </DataTable>
        ) : (
          <p className="performance-empty">Signal sikli hodisasi hali yo‘q.</p>
        )}
      </section>
    </>
  );
}
function formatDuration(milliseconds: number) {
  return milliseconds < 1000
    ? `${milliseconds} ms`
    : `${(milliseconds / 1000).toFixed(1)} s`;
}
function eventLabel(type: string) {
  return (
    (
      {
        published: "Yangi signal",
        activated: "Entry faollashdi",
        tp_hit: "Take Profit",
        stop_hit: "Stop Loss",
        expired: "Muddati tugadi",
        cancelled: "Bekor qilindi",
        stop_moved_to_breakeven: "Stop breakeven",
      } as Record<string, string>
    )[type] ?? type.replaceAll("_", " ")
  );
}
function PerformanceMetric({
  icon,
  label,
  value,
  hint,
}: {
  icon: ReactNode;
  label: string;
  value: string | number | undefined;
  hint: string;
}) {
  return (
    <article>
      <span>
        {icon}
        {label}
      </span>
      <strong>{value ?? "—"}</strong>
      <small>{hint}</small>
    </article>
  );
}
function Stat({
  icon,
  label,
  value,
}: {
  icon: ReactNode;
  label: string;
  value: string | number | undefined;
}) {
  return (
    <article>
      <span>
        {icon}
        {label}
      </span>
      <strong>{value ?? "—"}</strong>
      <small>Ishlab turgan D1 bazasi</small>
    </article>
  );
}
function Status({ name, ok }: { name: string; ok: boolean }) {
  return (
    <div className="system-row">
      <span className={ok ? "ok" : "warn"}>
        {ok ? <Check size={15} /> : <Clock3 size={15} />}
      </span>
      <strong>{name}</strong>
      <small>{ok ? "Ulangan" : "Sozlash kerak"}</small>
    </div>
  );
}
function Analyses() {
  const [items, setItems] = useState<Analysis[]>([]);
  useEffect(() => {
    getAnalyses().then(setItems);
  }, []);
  return (
    <>
      <PageTitle
        eyebrow="STRATEGIYA DVIGATELI"
        title="Jonli tahlillar"
        subtitle="Foydalanuvchi so‘rovlari, provayder va strategiya natijalari."
      />
      <DataTable
        headers={[
          "Foydalanuvchi",
          "Bozor",
          "Strategiyalar",
          "Natija",
          "Provayder vaqti",
        ]}
      >
        {items.map((item) => (
          <tr key={item.id}>
            <td>
              <strong>{item.firstName}</strong>
              <small>@{item.username ?? "—"}</small>
            </td>
            <td>
              <strong>{item.symbol}</strong>
              <small>{item.timeframe}</small>
            </td>
            <td>
              <div className="table-tags">
                {safeArray(item.strategiesJson)
                  .slice(0, 3)
                  .map((x) => (
                    <span key={x}>{strategyNameUz(x)}</span>
                  ))}
              </div>
            </td>
            <td>
              <span className={`status ${item.status}`}>
                {statusNameUz(item.status)}
              </span>
            </td>
            <td>
              {item.providerTimestamp ?? "—"}
              <small>{new Date(item.createdAt).toLocaleString()}</small>
            </td>
          </tr>
        ))}
      </DataTable>
    </>
  );
}
function Payments() {
  const [items, setItems] = useState<Payment[]>([]),
    [busy, setBusy] = useState("");
  const load = () => getPayments().then(setItems);
  useEffect(() => {
    void load();
  }, []);
  const review = async (id: string, status: "approved" | "rejected") => {
    setBusy(id);
    try {
      await reviewPayment(id, status);
      await load();
    } finally {
      setBusy("");
    }
  };
  return (
    <>
      <PageTitle
        eyebrow="TO‘LOV AMALIYOTLARI"
        title="To‘lov tekshiruvi"
        subtitle="R2’ga yuklangan cheklarni tasdiqlang va obunani yoqing."
      />
      <section className="payment-review-grid">
        {items.map((item) => (
          <article className="review-card" key={item.id}>
            <div className="review-head">
              <span className="receipt-icon">
                <FileCheck2 size={19} />
              </span>
              <div>
                <strong>{item.first_name}</strong>
                <small>
                  @{item.username ?? "—"} ·{" "}
                  {new Date(item.created_at).toLocaleString()}
                </small>
              </div>
              <span className={item.status}>{statusNameUz(item.status)}</span>
            </div>
            <dl>
              <div>
                <dt>Tarif</dt>
                <dd>{item.plan_code}</dd>
              </div>
              <div>
                <dt>Miqdor</dt>
                <dd>
                  {item.currency} {item.amount}
                </dd>
              </div>
            </dl>
            <button
              className="receipt-preview"
              onClick={() => void openReceipt(item.id)}
            >
              <FileCheck2 size={28} />
              <span>Saqlangan chek</span>
              <small>Chekni xavfsiz oynada ochish</small>
            </button>
            {item.status === "pending" && (
              <div className="review-actions">
                <button
                  disabled={busy === item.id}
                  className="reject"
                  onClick={() => review(item.id, "rejected")}
                >
                  <X size={16} />
                  Rad etish
                </button>
                <button
                  disabled={busy === item.id}
                  className="approve"
                  onClick={() => review(item.id, "approved")}
                >
                  <Check size={16} />
                  Tasdiqlash
                </button>
              </div>
            )}
          </article>
        ))}
      </section>
    </>
  );
}
function UsersView({
  canManageSubscriptions,
}: {
  canManageSubscriptions: boolean;
}) {
  const [items, setItems] = useState<User[]>([]),
    [query, setQuery] = useState(""),
    [busy, setBusy] = useState(""),
    [message, setMessage] = useState(""),
    [selected, setSelected] = useState<User | null>(null),
    [detail, setDetail] = useState<UserDetail | null>(null),
    [detailLoading, setDetailLoading] = useState(false),
    [detailError, setDetailError] = useState("");
  const load = () => getUsers().then(setItems);
  useEffect(() => {
    load();
  }, []);
  const filtered = items.filter((item) =>
    `${item.firstName} ${item.username ?? ""} ${item.telegramId} ${item.productCode ?? "FREE"}`
      .toLowerCase()
      .includes(query.toLowerCase()),
  );
  const loadDetail = async (item: User) => {
    setSelected(item);
    setDetail(null);
    setDetailError("");
    setDetailLoading(true);
    try {
      setDetail(await getUserDetail(item.id));
    } catch (error) {
      setDetailError(
        error instanceof Error ? error.message : "Ma’lumot yuklanmadi",
      );
    } finally {
      setDetailLoading(false);
    }
  };
  const refreshSelected = async (id: string) => {
    if (selected?.id === id) setDetail(await getUserDetail(id));
  };
  const changeStatus = async (item: User) => {
    const nextStatus = item.status === "active" ? "blocked" : "active";
    setBusy(item.id);
    setMessage("");
    try {
      await updateUserStatus(item.id, nextStatus);
      setSelected((current) =>
        current?.id === item.id ? { ...current, status: nextStatus } : current,
      );
      await load();
      await refreshSelected(item.id);
      setMessage("Foydalanuvchi holati yangilandi");
    } finally {
      setBusy("");
    }
  };
  const grant = async (item: User, productCode: "TRIAL" | "PRO" | "ELITE") => {
    setBusy(item.id);
    setMessage("");
    try {
      await grantSubscription(item.id, productCode);
      await load();
      await refreshSelected(item.id);
      setMessage(`${item.firstName} uchun ${productCode} faollashtirildi`);
    } finally {
      setBusy("");
    }
  };
  const cancelPlan = async (item: User) => {
    if (
      !window.confirm(
        `${item.firstName} foydalanuvchisining faol tarifi darhol bekor qilinadi. Davom etasizmi?`,
      )
    )
      return;
    setBusy(item.id);
    setMessage("");
    try {
      await cancelSubscription(item.id);
      await load();
      await refreshSelected(item.id);
      setMessage(`${item.firstName} foydalanuvchisining tarifi bekor qilindi`);
    } catch (error) {
      setMessage(
        error instanceof Error ? error.message : "Tarifni bekor qilib bo‘lmadi",
      );
    } finally {
      setBusy("");
    }
  };
  return (
    <>
      <PageTitle
        eyebrow="FOYDALANUVCHILARNI BOSHQARISH"
        title="Foydalanuvchilar"
        subtitle="Telegram hisoblari, tarif va oylik tahlil sarfi."
      />
      {message && <div className="settings-message">{message}</div>}
      <div className="user-search">
        <Search size={17} />
        <input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Ism, username, Telegram ID yoki tarif..."
        />
        <span>
          {filtered.length} / {items.length}
        </span>
      </div>
      <DataTable
        headers={[
          "Foydalanuvchi",
          "Telegram ID",
          "Tarif",
          "Tahlillar",
          "Holat",
          "Amallar",
          "Qo‘shilgan",
        ]}
      >
        {filtered.map((item) => (
          <tr key={item.id}>
            <td>
              <strong>{item.firstName}</strong>
              <small>@{item.username ?? "—"}</small>
            </td>
            <td>{item.telegramId}</td>
            <td>
              <span className="plan-badge">{item.productCode ?? "FREE"}</span>
            </td>
            <td>{item.analysesUsed}</td>
            <td>
              <span className={`status ${item.status}`}>
                {statusNameUz(item.status)}
              </span>
            </td>
            <td>
              <div className="user-actions">
                <button
                  className="detail-action"
                  onClick={() => loadDetail(item)}
                  aria-label={`${item.firstName} tafsilotlarini ochish`}
                >
                  <Eye size={15} />
                  <span>Batafsil</span>
                </button>
                {canManageSubscriptions && (
                  <select
                    aria-label="Tarif berish"
                    disabled={busy === item.id}
                    defaultValue=""
                    onChange={(e) => {
                      if (e.target.value)
                        grant(
                          item,
                          e.target.value as "TRIAL" | "PRO" | "ELITE",
                        );
                      e.currentTarget.value = "";
                    }}
                  >
                    <option value="" disabled>
                      Tarif berish
                    </option>
                    <option value="TRIAL">TRIAL · 7 kun</option>
                    <option value="PRO">PRO · 30 kun</option>
                    <option value="ELITE">ELITE · 30 kun</option>
                  </select>
                )}
                <button
                  disabled={busy === item.id}
                  className={
                    item.status === "active"
                      ? "danger-action"
                      : "success-action"
                  }
                  onClick={() => changeStatus(item)}
                >
                  {item.status === "active" ? (
                    <Ban size={15} />
                  ) : (
                    <UserCheck size={15} />
                  )}
                  <span>
                    {item.status === "active" ? "Bloklash" : "Ochish"}
                  </span>
                </button>
              </div>
            </td>
            <td>{new Date(item.createdAt).toLocaleDateString()}</td>
          </tr>
        ))}
      </DataTable>
      {selected && (
        <UserDetailDrawer
          item={selected}
          detail={detail}
          loading={detailLoading}
          error={detailError}
          busy={busy === selected.id}
          canManageSubscriptions={canManageSubscriptions}
          onClose={() => {
            setSelected(null);
            setDetail(null);
          }}
          onGrant={(plan) => grant(selected, plan)}
          onCancelSubscription={() => cancelPlan(selected)}
          onToggleStatus={() =>
            changeStatus({
              ...selected,
              status: detail?.user.status ?? selected.status,
            })
          }
        />
      )}
    </>
  );
}
function UserDetailDrawer({
  item,
  detail,
  loading,
  error,
  busy,
  canManageSubscriptions,
  onClose,
  onGrant,
  onCancelSubscription,
  onToggleStatus,
}: {
  item: User;
  detail: UserDetail | null;
  loading: boolean;
  error: string;
  busy: boolean;
  canManageSubscriptions: boolean;
  onClose: () => void;
  onGrant: (plan: "TRIAL" | "PRO" | "ELITE") => void;
  onCancelSubscription: () => void;
  onToggleStatus: () => void;
}) {
  const closeRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    closeRef.current?.focus();
    const escape = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", escape);
    return () => {
      document.body.style.overflow = previous;
      window.removeEventListener("keydown", escape);
    };
  }, []);
  const access = detail?.access;
  return (
    <div className="detail-layer">
      <button
        className="detail-scrim"
        aria-label="Foydalanuvchi tafsilotlarini yopish"
        onClick={onClose}
      />
      <aside
        className="user-detail-drawer"
        role="dialog"
        aria-modal="true"
        aria-labelledby="user-detail-title"
      >
        <header className="drawer-head">
          <div className="drawer-identity">
            <span>{item.firstName.slice(0, 2).toUpperCase()}</span>
            <div>
              <p className="eyebrow">FOYDALANUVCHI PROFILI</p>
              <h2 id="user-detail-title">{item.firstName}</h2>
              <small>
                @{item.username ?? "username yo‘q"} · {item.telegramId}
              </small>
            </div>
          </div>
          <button
            ref={closeRef}
            className="drawer-close"
            onClick={onClose}
            aria-label="Yopish"
          >
            <X size={20} />
          </button>
        </header>
        {loading && (
          <div className="drawer-loading">
            <RefreshCw className="spin" size={22} />
            <span>Ma’lumotlar yuklanmoqda...</span>
          </div>
        )}
        {error && <div className="admin-error">{error}</div>}
        {detail && (
          <div className="drawer-content">
            <section className="drawer-metrics">
              <article>
                <span>Joriy tarif</span>
                <strong>{access?.productCode}</strong>
                <small>
                  {access?.aiAssistant
                    ? "AI yordamchi faol"
                    : "Standart access"}
                </small>
              </article>
              <article>
                <span>Tahlil sarfi</span>
                <strong>
                  {access?.analysesUsed}
                  {access?.analysisLimit === null
                    ? " / ∞"
                    : ` / ${access?.analysisLimit}`}
                </strong>
                <small>
                  {access?.analysesRemaining === null
                    ? "Cheksiz"
                    : `${access?.analysesRemaining} ta qoldi`}
                </small>
              </article>
              <article>
                <span>Amal qilish</span>
                <strong>
                  {access?.expiresAt
                    ? new Date(access.expiresAt).toLocaleDateString()
                    : "Muddatsiz"}
                </strong>
                <small>{statusNameUz(detail.user.status)}</small>
              </article>
            </section>
            <section className="drawer-section">
              <div className="drawer-section-head">
                <h3>Hisob ma’lumotlari</h3>
                <span className={`status ${detail.user.status}`}>
                  {statusNameUz(detail.user.status)}
                </span>
              </div>
              <dl className="profile-facts">
                <div>
                  <dt>Telegram ID</dt>
                  <dd>{detail.user.telegramId}</dd>
                </div>
                <div>
                  <dt>Ilova tili</dt>
                  <dd>{detail.user.appLanguage.toUpperCase()}</dd>
                </div>
                <div>
                  <dt>Ro‘yxatdan o‘tgan</dt>
                  <dd>{formatAdminDate(detail.user.createdAt)}</dd>
                </div>
                <div>
                  <dt>Oxirgi faollik</dt>
                  <dd>{formatAdminDate(detail.user.lastSeenAt)}</dd>
                </div>
              </dl>
            </section>
            <section className="drawer-section">
              <div className="drawer-section-head">
                <h3>Tezkor boshqaruv</h3>
              </div>
              <div className="drawer-actions">
                {canManageSubscriptions && (
                  <select
                    aria-label="Yangi tarif"
                    disabled={busy}
                    defaultValue=""
                    onChange={(event) => {
                      if (event.target.value)
                        onGrant(
                          event.target.value as "TRIAL" | "PRO" | "ELITE",
                        );
                      event.currentTarget.value = "";
                    }}
                  >
                    <option value="" disabled>
                      Tarifni tanlang
                    </option>
                    <option value="TRIAL">TRIAL</option>
                    <option value="PRO">PRO</option>
                    <option value="ELITE">ELITE</option>
                  </select>
                )}
                {canManageSubscriptions &&
                  detail.subscriptions.some(
                    (row) => row.status === "active",
                  ) && (
                    <button
                      disabled={busy}
                      className="danger-action"
                      onClick={onCancelSubscription}
                    >
                      <CircleX size={16} /> Tarifni bekor qilish
                    </button>
                  )}
                <button
                  disabled={busy}
                  className={
                    detail.user.status === "active"
                      ? "danger-action"
                      : "success-action"
                  }
                  onClick={onToggleStatus}
                >
                  {detail.user.status === "active" ? (
                    <Ban size={16} />
                  ) : (
                    <UserCheck size={16} />
                  )}{" "}
                  {detail.user.status === "active"
                    ? "Bloklash"
                    : "Qayta ochish"}
                </button>
              </div>
            </section>
            <DrawerHistory title="Obuna tarixi" empty="Obuna tarixi yo‘q">
              {detail.subscriptions.slice(0, 6).map((row) => (
                <article className="history-row" key={row.id}>
                  <div>
                    <strong>{row.productCode}</strong>
                    <small>{providerNameUz(row.source)}</small>
                  </div>
                  <span className={`status ${row.status}`}>
                    {statusNameUz(row.status)}
                  </span>
                  <time>{formatAdminDate(row.expiresAt ?? row.createdAt)}</time>
                </article>
              ))}
            </DrawerHistory>
            <DrawerHistory title="To‘lovlar" empty="To‘lov yuborilmagan">
              {detail.payments.slice(0, 6).map((row) => (
                <article className="history-row" key={row.id}>
                  <div>
                    <strong>
                      {row.amount} {row.currency}
                    </strong>
                    <small>{row.planCode}</small>
                  </div>
                  <span className={`status ${row.status}`}>
                    {statusNameUz(row.status)}
                  </span>
                  <time>{formatAdminDate(row.createdAt)}</time>
                </article>
              ))}
            </DrawerHistory>
            <DrawerHistory title="Oxirgi tahlillar" empty="Tahlil bajarilmagan">
              {detail.analyses.slice(0, 10).map((row) => (
                <article className="history-row" key={row.id}>
                  <div>
                    <strong>
                      {row.symbol} · {row.timeframe}
                    </strong>
                    <small>{providerNameUz(row.provider)}</small>
                  </div>
                  <span className={`status ${row.status}`}>
                    {statusNameUz(row.status)}
                  </span>
                  <time>{formatAdminDate(row.createdAt)}</time>
                </article>
              ))}
            </DrawerHistory>
          </div>
        )}
      </aside>
    </div>
  );
}
function DrawerHistory({
  title,
  empty,
  children,
}: {
  title: string;
  empty: string;
  children: ReactNode;
}) {
  const hasItems = Array.isArray(children)
    ? children.length > 0
    : Boolean(children);
  return (
    <section className="drawer-section">
      <div className="drawer-section-head">
        <h3>{title}</h3>
      </div>
      <div className="drawer-history">
        {hasItems ? children : <p className="drawer-empty">{empty}</p>}
      </div>
    </section>
  );
}
function formatAdminDate(value: string) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  const parts = new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).formatToParts(date);
  const part = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((item) => item.type === type)?.value ?? "";
  return `${part("day")}.${part("month")}.${part("year")}, ${part("hour")}:${part("minute")}`;
}
function AuditView() {
  const [items, setItems] = useState<AuditLog[]>([]),
    [query, setQuery] = useState("");
  useEffect(() => {
    getAuditLogs().then(setItems);
  }, []);
  const filtered = items.filter((x) =>
    `${x.action} ${x.entityType} ${x.entityId} ${x.adminId}`
      .toLowerCase()
      .includes(query.toLowerCase()),
  );
  return (
    <>
      <PageTitle
        eyebrow="XAVFSIZLIK VA HISOBDORLIK"
        title="Audit tarixi"
        subtitle="Admin bajargan muhim amallarning o‘zgarmas jurnali."
        action={
          <button className="secondary" onClick={() => void exportAuditCsv()}>
            <Download size={16} />
            CSV eksport
          </button>
        }
      />
      <div className="user-search">
        <Search size={17} />
        <input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Amal yoki obyekt bo‘yicha qidirish..."
        />
        <span>{filtered.length} yozuv</span>
      </div>
      <DataTable
        headers={["Vaqt", "Amal", "Obyekt", "Administrator", "Yangi qiymat"]}
      >
        {filtered.map((item) => (
          <tr key={item.id}>
            <td>{new Date(item.createdAt).toLocaleString()}</td>
            <td>
              <span className="audit-action">{item.action}</span>
            </td>
            <td>
              <strong>{item.entityType}</strong>
              <small>{item.entityId}</small>
            </td>
            <td>{item.adminId}</td>
            <td>
              <code className="audit-json">{item.afterJson ?? "—"}</code>
            </td>
          </tr>
        ))}
      </DataTable>
    </>
  );
}
function DataTable({
  headers,
  children,
}: {
  headers: string[];
  children: ReactNode;
}) {
  return (
    <section className="table-card">
      <div className="table-tools">
        <div className="global-search">
          <Search size={17} />
          <input placeholder="Qidirish..." />
        </div>
      </div>
      <div className="responsive-table">
        <table>
          <thead>
            <tr>
              {headers.map((h) => (
                <th key={h}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>{children}</tbody>
        </table>
      </div>
    </section>
  );
}
function PlanSettings() {
  const [data, setData] = useState<PlatformSettings | null>(null),
    [provider, setProvider] = useState<{
      name: string;
      configured: boolean;
    } | null>(null),
    [ai, setAi] = useState<{ name: string; configured: boolean } | null>(null),
    [message, setMessage] = useState("");
  useEffect(() => {
    getPlatformSettings().then((r) => {
      setData(r.settings);
      setProvider(r.provider);
      setAi(r.ai);
    });
  }, []);
  if (!data) return <p>Yuklanmoqda...</p>;
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    await updatePlatformSettings(data);
    setMessage("Limitlar saqlandi");
  };
  return (
    <>
      <PageTitle
        eyebrow="MONETIZATSIYA VA LIMITLAR"
        title="Tarif va limitlar"
        subtitle="Interfeysga qotirib yozilmagan server biznes qoidalari."
      />
      <div className="settings-grid">
        <form className="settings-form" onSubmit={submit}>
          <div className="settings-form-head">
            <Gauge size={20} />
            <div>
              <h2>Tahlil limitlari</h2>
              <p>O‘zgarish darhol barcha userlarga qo‘llanadi</p>
            </div>
          </div>
          {(
            [
              ["free_monthly_analyses", "FREE · oyiga"],
              ["trial_total_analyses", "TRIAL · jami"],
              ["pro_monthly_analyses", "PRO · oyiga"],
              ["trial_days", "TRIAL muddati"],
              ["pro_days", "PRO muddati"],
              ["elite_days", "ELITE muddati"],
              ["news_blackout_minutes", "High-impact blackout · daqiqa"],
            ] as const
          ).map(([key, label]) => (
            <label key={key}>
              {label}
              <input
                type="number"
                min={
                  key === "free_monthly_analyses" ||
                  key === "news_blackout_minutes"
                    ? 0
                    : 1
                }
                value={data[key]}
                onChange={(e) =>
                  setData({ ...data, [key]: Number(e.target.value) })
                }
              />
            </label>
          ))}
          {message && <p className="settings-message">{message}</p>}
          <button className="primary">Saqlash</button>
        </form>
        <section className="admin-card system-card">
          <div className="card-heading">
            <div>
              <h2>Tahlil provayderlari</h2>
              <p>Maxfiy kalitlar Worker maxfiy sozlamalarida</p>
            </div>
          </div>
          <Status
            name={provider?.name ?? "Twelve Data"}
            ok={Boolean(provider?.configured)}
          />
          <Status
            name={ai?.name ?? "Workers AI"}
            ok={Boolean(ai?.configured)}
          />
          <p className="provider-help">
            Bozor provayderi qizil bo‘lsa, `TWELVE_DATA_API_KEY` maxfiy kalitini
            ishlab turgan Worker xizmatiga kiriting.
          </p>
        </section>
      </div>
    </>
  );
}
function PaymentSettingsView() {
  const [data, setData] = useState<PaymentSettings | null>(null),
    [message, setMessage] = useState("");
  useEffect(() => {
    getPaymentSettings().then(setData);
  }, []);
  if (!data) return <p>Yuklanmoqda...</p>;
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setData(await updatePaymentSettings(data));
    setMessage("To‘lov sozlamalari saqlandi");
  };
  return (
    <>
      <PageTitle
        eyebrow="TO‘LOV SOZLAMALARI"
        title="To‘lov sozlamalari"
        subtitle="Karta, valuta va uchta tarif narxini boshqaring."
      />
      <form className="settings-form wide" onSubmit={submit}>
        <div className="settings-form-head">
          <CreditCard size={20} />
          <div>
            <h2>Manual karta to‘lovi</h2>
            <p>Cheklar Cloudflare R2’da saqlanadi</p>
          </div>
        </div>
        <label>
          Karta raqami
          <input
            required
            value={data.cardNumber}
            onChange={(e) => setData({ ...data, cardNumber: e.target.value })}
          />
        </label>
        <label>
          Karta egasi
          <input
            required
            value={data.cardHolder}
            onChange={(e) =>
              setData({ ...data, cardHolder: e.target.value.toUpperCase() })
            }
          />
        </label>
        <div className="form-grid">
          <label>
            TRIAL · 7 kun
            <input
              type="number"
              value={data.trial7Price}
              onChange={(e) =>
                setData({ ...data, trial7Price: Number(e.target.value) })
              }
            />
          </label>
          <label>
            PRO · 30 kun
            <input
              type="number"
              value={data.pro30Price}
              onChange={(e) =>
                setData({ ...data, pro30Price: Number(e.target.value) })
              }
            />
          </label>
          <label>
            ELITE · 30 kun
            <input
              type="number"
              value={data.elite30Price}
              onChange={(e) =>
                setData({ ...data, elite30Price: Number(e.target.value) })
              }
            />
          </label>
          <label>
            Valuta
            <select
              value={data.currency}
              onChange={(e) =>
                setData({ ...data, currency: e.target.value as "USD" | "UZS" })
              }
            >
              <option>USD</option>
              <option>UZS</option>
            </select>
          </label>
        </div>
        {message && <p className="settings-message">{message}</p>}
        <button className="primary">Saqlash</button>
      </form>
    </>
  );
}
function RiskControlView() {
  const [data, setData] = useState<RiskControls | null>(null),
    [message, setMessage] = useState(""),
    [error, setError] = useState("");
  const load = () =>
    getRiskControls()
      .then(setData)
      .catch((e) => setError(e instanceof Error ? e.message : "Yuklanmadi"));
  useEffect(() => {
    void load();
  }, []);
  if (!data)
    return <p className="loading-state">Xavf sozlamalari yuklanmoqda...</p>;
  const save = async (next = data) => {
    setError("");
    setMessage("");
    try {
      await updateRiskControls({
        signalsEnabled: next.signalsEnabled,
        minSignalConfidence: next.minSignalConfidence,
        minRiskReward: next.minRiskReward,
        dailySignalLimit: next.dailySignalLimit,
        assetCooldownMinutes: next.assetCooldownMinutes,
      });
      setData(next);
      setMessage("Xavf sozlamalari saqlandi");
    } catch (e) {
      setError(e instanceof Error ? e.message : "Saqlanmadi");
    }
  };
  const toggleEngine = () => {
    const next = { ...data, signalsEnabled: !data.signalsEnabled };
    if (
      !next.signalsEnabled &&
      !window.confirm(
        "Barcha yangi signallarni darhol to‘xtatishni tasdiqlaysizmi?",
      )
    )
      return;
    void save(next);
  };
  return (
    <>
      <PageTitle
        eyebrow="SAVDO XAVFSIZLIGI QATLAMI"
        title="Xavf nazorati"
        subtitle="Signal dvigatelining global holati, sifat chegaralari va kunlik limitlari."
        action={
          <button
            className={data.signalsEnabled ? "danger-button" : "primary"}
            onClick={toggleEngine}
          >
            <Power size={17} />
            {data.signalsEnabled
              ? "Signallarni to‘xtatish"
              : "Signallarni yoqish"}
          </button>
        }
      />
      <div
        className={`engine-banner ${data.signalsEnabled ? "running" : "paused"}`}
      >
        <ShieldAlert />
        <div>
          <strong>
            {data.signalsEnabled
              ? "Signal dvigateli ishlayapti"
              : "Signal dvigateli to‘xtatilgan"}
          </strong>
          <span>
            {data.signalsToday} / {data.dailySignalLimit} signal bugun yaratildi
          </span>
        </div>
      </div>
      {error && <p className="admin-error">{error}</p>}
      {message && <p className="settings-message">{message}</p>}
      <div className="ops-grid">
        <form
          className="settings-form wide"
          onSubmit={(e) => {
            e.preventDefault();
            void save();
          }}
        >
          <div className="settings-form-head">
            <Gauge />
            <div>
              <h2>Sifat filtrlari</h2>
              <p>
                Faqat belgilangan chegaradan o‘tgan savdo holati chiqariladi
              </p>
            </div>
          </div>
          <div className="form-grid">
            <label>
              Minimal ishonch (%)
              <input
                type="number"
                min="50"
                max="95"
                value={data.minSignalConfidence}
                onChange={(e) =>
                  setData({
                    ...data,
                    minSignalConfidence: Number(e.target.value),
                  })
                }
              />
            </label>
            <label>
              Minimal xavf/foyda nisbati
              <input
                type="number"
                step="0.1"
                min="1"
                max="5"
                value={data.minRiskReward}
                onChange={(e) =>
                  setData({ ...data, minRiskReward: Number(e.target.value) })
                }
              />
            </label>
            <label>
              Kunlik signal limiti
              <input
                type="number"
                min="0"
                max="200"
                value={data.dailySignalLimit}
                onChange={(e) =>
                  setData({ ...data, dailySignalLimit: Number(e.target.value) })
                }
              />
            </label>
            <label>
              Aktiv cooldown (daqiqa)
              <input
                type="number"
                min="0"
                max="1440"
                value={data.assetCooldownMinutes}
                onChange={(e) =>
                  setData({
                    ...data,
                    assetCooldownMinutes: Number(e.target.value),
                  })
                }
              />
            </label>
          </div>
          <button className="primary">Saqlash</button>
        </form>
        <section className="admin-card">
          <div className="card-heading">
            <h2>Oxirgi avtomatik signallar</h2>
            <p>Xavf nazoratidan o‘tgan signallar</p>
          </div>
          {data.recentSignals.length ? (
            data.recentSignals.map((s) => (
              <div className="compact-row" key={s.id}>
                <div>
                  <strong>
                    {s.symbol} · {directionNameUz(s.direction)}
                  </strong>
                  <small>{new Date(s.createdAt).toLocaleString()}</small>
                </div>
                <b>{s.confidence}%</b>
              </div>
            ))
          ) : (
            <p className="empty-copy">Hali signal yo‘q</p>
          )}
        </section>
      </div>
    </>
  );
}
function RevenueView() {
  const [period, setPeriod] = useState<30 | 90 | 365>(30),
    [data, setData] = useState<Revenue | null>(null),
    [error, setError] = useState("");
  useEffect(() => {
    getRevenue(period)
      .then(setData)
      .catch((e) => setError(e instanceof Error ? e.message : "Yuklanmadi"));
  }, [period]);
  const money = (v: number) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(v);
  const max = Math.max(
    1,
    ...(data?.daily.map((d) => Number(d.revenue)) ?? [1]),
  );
  return (
    <>
      <PageTitle
        eyebrow="MOLIYAVIY TAHLIL"
        title="Tushum va konversiya"
        subtitle="Tasdiqlangan to‘lovlar, tariflar va obuna konversiyasi."
        action={
          <select
            value={period}
            onChange={(e) => setPeriod(Number(e.target.value) as 30 | 90 | 365)}
          >
            <option value="30">30 kun</option>
            <option value="90">90 kun</option>
            <option value="365">1 yil</option>
          </select>
        }
      />
      {error && <p className="admin-error">{error}</p>}
      <section className="admin-stats">
        <Stat
          icon={<WalletCards />}
          label="Tushum"
          value={data ? money(data.revenue) : undefined}
        />
        <Stat
          icon={<CircleDollarSign />}
          label="O‘rtacha chek"
          value={data ? money(data.averageOrder) : undefined}
        />
        <Stat
          icon={<Clock3 />}
          label="Kutilayotgan"
          value={data ? money(data.pendingAmount) : undefined}
        />
        <Stat
          icon={<TrendingUp />}
          label="Trial → paid"
          value={data ? `${data.trialConversionRate}%` : undefined}
        />
      </section>
      <div className="dashboard-grid">
        <section className="admin-card revenue-chart">
          <div className="card-heading">
            <h2>Kunlik tushum</h2>
            <p>{data?.approvedCount ?? 0} ta tasdiqlangan to‘lov</p>
          </div>
          <div className="revenue-bars">
            {data?.daily.map((d) => (
              <div key={d.day} title={`${d.day}: ${money(Number(d.revenue))}`}>
                <i
                  style={{
                    height: `${Math.max(5, (Number(d.revenue) / max) * 100)}%`,
                  }}
                />
                <small>{d.day.slice(5)}</small>
              </div>
            ))}
          </div>
        </section>
        <section className="admin-card">
          <div className="card-heading">
            <h2>Tariflar kesimi</h2>
            <p>Keyingi 7 kunda {data?.expiringNext7Days ?? 0} obuna tugaydi</p>
          </div>
          {data?.plans.map((p) => (
            <div className="compact-row" key={p.planCode}>
              <div>
                <strong>{p.planCode}</strong>
                <small>{p.count} ta to‘lov</small>
              </div>
              <b>{money(Number(p.revenue))}</b>
            </div>
          ))}
        </section>
      </div>
    </>
  );
}
function BroadcastView() {
  const [items, setItems] = useState<Broadcast[]>([]),
    [segment, setSegment] = useState("all"),
    [uz, setUz] = useState(""),
    [ru, setRu] = useState(""),
    [schedule, setSchedule] = useState(""),
    [busy, setBusy] = useState(false),
    [error, setError] = useState("");
  const load = () =>
    getBroadcasts()
      .then(setItems)
      .catch((e) => setError(e instanceof Error ? e.message : "Yuklanmadi"));
  useEffect(() => {
    void load();
  }, []);
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await createBroadcast({
        segment,
        messageUz: uz,
        messageRu: ru,
        scheduledAt: schedule ? new Date(schedule).toISOString() : null,
      });
      setUz("");
      setRu("");
      setSchedule("");
      await load();
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : "Saqlanmadi");
    } finally {
      setBusy(false);
    }
  };
  const send = async (id: string) => {
    setBusy(true);
    setError("");
    try {
      const preview = await getBroadcastPreview(id);
      if (!preview.audience.total) {
        setError("Tanlangan segmentda faol foydalanuvchi yo‘q.");
        return;
      }
      if (
        !window.confirm(
          `${preview.audience.total} ta real Telegram foydalanuvchisiga yuboriladi: ${preview.audience.uz} UZ, ${preview.audience.ru} RU. Davom etasizmi?`,
        )
      )
        return;
      await sendBroadcast(id, preview.audience.total);
      await load();
    } catch (e) {
      setError(e instanceof Error ? e.message : "Yuborilmadi");
    } finally {
      setBusy(false);
    }
  };
  const cancel = async (id: string) => {
    if (
      !window.confirm("Rejalashtirilgan xabar bekor qilinadi. Davom etasizmi?")
    )
      return;
    setBusy(true);
    try {
      await cancelBroadcast(id);
      await load();
    } catch (e) {
      setError(e instanceof Error ? e.message : "Bekor qilinmadi");
    } finally {
      setBusy(false);
    }
  };
  const minSchedule = new Date(
    Date.now() + 120_000 - new Date().getTimezoneOffset() * 60_000,
  )
    .toISOString()
    .slice(0, 16);
  return (
    <>
      <PageTitle
        eyebrow="TELEGRAM ALOQALARI"
        title="Xabarnomalar"
        subtitle="UZ/RU segmentlangan xabarlarni hozir yoki reja bo‘yicha yuboring."
      />
      {error && <p className="admin-error">{error}</p>}
      <div className="broadcast-grid">
        <form className="settings-form wide" onSubmit={submit}>
          <div className="settings-form-head">
            <Megaphone />
            <div>
              <h2>Yangi xabar</h2>
              <p>Ikki tildagi matn majburiy</p>
            </div>
          </div>
          <label>
            Auditoriya
            <select
              value={segment}
              onChange={(e) => setSegment(e.target.value)}
            >
              <option value="all">Barcha faol foydalanuvchilar</option>
              <option value="free">FREE</option>
              <option value="trial">TRIAL</option>
              <option value="pro">PRO</option>
              <option value="elite">ELITE</option>
            </select>
          </label>
          <label>
            Rejalashtirish (ixtiyoriy)
            <input
              type="datetime-local"
              min={minSchedule}
              value={schedule}
              onChange={(e) => setSchedule(e.target.value)}
            />
            <small>
              Bo‘sh qoldirilsa qoralama; reja cron sabab 5 daqiqagacha
              kechikishi mumkin
            </small>
          </label>
          <label>
            O‘zbekcha
            <textarea
              required
              minLength={3}
              maxLength={4000}
              rows={6}
              value={uz}
              onChange={(e) => setUz(e.target.value)}
            />
            <small>{uz.length}/4000</small>
          </label>
          <label>
            Русский
            <textarea
              required
              minLength={3}
              maxLength={4000}
              rows={6}
              value={ru}
              onChange={(e) => setRu(e.target.value)}
            />
            <small>{ru.length}/4000</small>
          </label>
          <button className="primary" disabled={busy}>
            {busy
              ? "Saqlanmoqda..."
              : schedule
                ? "Rejalashtirish"
                : "Qoralama saqlash"}
          </button>
        </form>
        <section className="admin-card">
          <div className="card-heading">
            <h2>Xabarlar tarixi</h2>
            <p>{items.length} ta kampaniya</p>
          </div>
          {items.map((i) => (
            <article className="broadcast-item" key={i.id}>
              <div>
                <span className={`status ${i.status}`}>
                  {statusNameUz(i.status)}
                </span>
                <b>{i.segment.toUpperCase()}</b>
                <small>
                  {i.scheduledAt
                    ? `Reja: ${new Date(i.scheduledAt).toLocaleString()}`
                    : new Date(i.createdAt).toLocaleString()}
                </small>
              </div>
              <p>{i.messageUz}</p>
              <footer>
                <span>
                  {i.successCount}/{i.recipientCount} yetkazildi
                </span>
                <div className="broadcast-actions">
                  {i.status === "draft" && !i.scheduledAt && (
                    <button
                      className="secondary"
                      disabled={busy}
                      onClick={() => void send(i.id)}
                    >
                      <Megaphone size={15} />
                      Yuborish
                    </button>
                  )}
                  {i.status === "draft" && i.scheduledAt && (
                    <button
                      className="secondary"
                      disabled={busy}
                      onClick={() => void cancel(i.id)}
                    >
                      <X size={15} />
                      Bekor qilish
                    </button>
                  )}
                </div>
              </footer>
            </article>
          ))}
        </section>
      </div>
    </>
  );
}
function AlertsView({ owner }: { owner: boolean }) {
  const [items, setItems] = useState<AdminAlert[]>([]),
    [chatId, setChatId] = useState(""),
    [saved, setSaved] = useState(""),
    [error, setError] = useState("");
  const load = () =>
    getAdminAlerts()
      .then(setItems)
      .catch((e) => setError(e instanceof Error ? e.message : "Yuklanmadi"));
  useEffect(() => {
    void load();
    if (owner) void getAlertSettings().then((x) => setChatId(x.telegramChatId));
  }, [owner]);
  return (
    <>
      <PageTitle
        eyebrow="AMALIY OGOHLANTIRISHLAR"
        title="Ogohlantirishlar"
        subtitle="Deduplikatsiya qilingan tizim va savdo xavfsizligi hodisalari."
        action={
          <button className="secondary" onClick={load}>
            <RefreshCw size={16} />
            Yangilash
          </button>
        }
      />
      {error && <p className="admin-error">{error}</p>}
      {owner && (
        <form
          className="alert-settings"
          onSubmit={(e) => {
            e.preventDefault();
            setSaved("");
            void updateAlertSettings(chatId)
              .then(() => setSaved("Telegram alert kanali saqlandi"))
              .catch((reason) =>
                setError(
                  reason instanceof Error ? reason.message : "Saqlanmadi",
                ),
              );
          }}
        >
          <div>
            <strong>Telegram ogohlantirish kanali</strong>
            <small>Kritik cron xatolari shu chat ID’ga yuboriladi</small>
          </div>
          <input
            aria-label="Telegram chat ID"
            value={chatId}
            onChange={(e) => setChatId(e.target.value)}
            placeholder="-1001234567890"
            inputMode="numeric"
          />
          <button className="secondary">Saqlash</button>
          {saved && <span>{saved}</span>}
        </form>
      )}
      <section className="alert-list">
        {items.length ? (
          items.map((a) => (
            <article className={`alert-card ${a.severity}`} key={a.id}>
              <AlertTriangle />
              <div>
                <header>
                  <strong>{a.title}</strong>
                  <span>{a.severity}</span>
                </header>
                <p>{a.message}</p>
                <small>
                  {categoryNameUz(a.category)} ·{" "}
                  {new Date(a.createdAt).toLocaleString()}
                </small>
              </div>
              {a.status === "open" ? (
                <button
                  className="secondary"
                  onClick={() => void acknowledgeAlert(a.id).then(load)}
                >
                  Ko‘rib chiqildi
                </button>
              ) : (
                <span className="status approved">yopilgan</span>
              )}
            </article>
          ))
        ) : (
          <p className="empty-copy">Ochiq ogohlantirish yo‘q.</p>
        )}
      </section>
    </>
  );
}
function TeamView() {
  const [items, setItems] = useState<AdminAccount[]>([]),
    [error, setError] = useState("");
  const load = () =>
    getAdminAccounts()
      .then(setItems)
      .catch((e) => setError(e instanceof Error ? e.message : "Yuklanmadi"));
  useEffect(() => {
    void load();
  }, []);
  const submit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const f = new FormData(e.currentTarget);
    try {
      await createAdminAccount({
        username: String(f.get("username")),
        password: String(f.get("password")),
        role: String(f.get("role")) as AdminAccount["role"],
      });
      e.currentTarget.reset();
      await load();
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : "Yaratilmadi");
    }
  };
  return (
    <>
      <PageTitle
        eyebrow="ROLLARGA ASOSLANGAN RUXSAT"
        title="Admin jamoasi"
        subtitle="Asosiy administrator, moliya menejeri, yordam operatori va tahlilchi uchun minimal ruxsatlar."
      />
      {error && <p className="admin-error">{error}</p>}
      <div className="team-grid">
        <form className="settings-form" onSubmit={submit}>
          <div className="settings-form-head">
            <UserCog />
            <div>
              <h2>Admin qo‘shish</h2>
              <p>Parol kamida 12 belgi</p>
            </div>
          </div>
          <label>
            Login
            <input name="username" required minLength={3} />
          </label>
          <label>
            Vaqtinchalik parol
            <input name="password" type="password" required minLength={12} />
          </label>
          <label>
            Rol
            <select name="role">
              <option value="support">Yordam operatori</option>
              <option value="analyst">Tahlilchi</option>
              <option value="finance">Moliya menejeri</option>
              <option value="owner">Asosiy administrator</option>
            </select>
          </label>
          <button className="primary">Administrator yaratish</button>
        </form>
        <section className="admin-card">
          <div className="card-heading">
            <h2>Jamoa</h2>
            <p>{items.length} ta qo‘shimcha admin</p>
          </div>
          {items.map((a) => (
            <div className="team-row" key={a.id}>
              <div className="avatar">
                {a.username.slice(0, 2).toUpperCase()}
              </div>
              <div>
                <strong>{a.username}</strong>
                <small>
                  Oxirgi kirish:{" "}
                  {a.lastLoginAt
                    ? new Date(a.lastLoginAt).toLocaleString()
                    : "hali kirmagan"}
                </small>
              </div>
              <select
                value={a.role}
                onChange={(e) =>
                  void updateAdminAccount(a.id, {
                    role: e.target.value as AdminAccount["role"],
                    status: a.status,
                  }).then(load)
                }
              >
                <option value="support">Yordam operatori</option>
                <option value="analyst">Tahlilchi</option>
                <option value="finance">Moliya menejeri</option>
                <option value="owner">Asosiy administrator</option>
              </select>
              <button
                className="secondary"
                onClick={() => {
                  if (
                    window.confirm(
                      `${a.username} hisobining holatini o‘zgartirasizmi?`,
                    )
                  )
                    void updateAdminAccount(a.id, {
                      role: a.role,
                      status: a.status === "active" ? "disabled" : "active",
                    }).then(load);
                }}
              >
                {a.status === "active" ? "O‘chirish" : "Yoqish"}
              </button>
            </div>
          ))}
        </section>
      </div>
    </>
  );
}
function MarketScannerView() {
  const [market, setMarket] = useState<AdminMarketStatus | null>(null);
  const [scanner, setScanner] = useState<AdminScanner | null>(null);
  const [error, setError] = useState("");
  const [running, setRunning] = useState(false);
  const load = () => {
    setError("");
    void Promise.all([getAdminMarketStatus(), getAdminScanner()])
      .then(([m, s]) => {
        setMarket(m);
        setScanner(s);
      })
      .catch((e: unknown) =>
        setError(e instanceof Error ? e.message : "Monitoring yuklanmadi"),
      );
  };
  useEffect(load, []);
  const runNow = async () => {
    setRunning(true);
    setError("");
    try {
      await runAdminScanner();
      load();
    } catch (reason) {
      setError(
        reason instanceof Error ? reason.message : "Skaner ishga tushmadi",
      );
    } finally {
      setRunning(false);
    }
  };
  const cells = new Map(
    scanner?.items.map((x) => [`${x.symbol}:${x.timeframe}`, x]) ?? [],
  );
  const symbols = [
    "XAUUSD",
    "EURUSD",
    "GBPUSD",
    "USDJPY",
    "AUDUSD",
    "USDCAD",
    "USDCHF",
    "NZDUSD",
  ];
  const tfs = ["M5", "M15", "M30", "H1", "H4"];
  return (
    <>
      <PageTitle
        eyebrow="JONLI BOZOR AMALIYOTLARI"
        title="Bozor va signal skaneri"
        subtitle="Provayder kechikishi, avtomatik himoya, 8×5 xarita va strategiya bosqichlari."
        action={
          <div className="title-actions">
            <button className="secondary" onClick={load}>
              <RefreshCw size={16} />
              Yangilash
            </button>
            <button className="primary" disabled={running} onClick={runNow}>
              <Play size={16} />
              {running ? "Skan qilinmoqda…" : "Skan hozir"}
            </button>
          </div>
        }
      />
      {error && <p className="admin-error">{error}</p>}
      <section className="admin-stats">
        <Stat
          icon={<Activity />}
          label="Bozor"
          value={market?.marketClosed ? "Yopiq" : "Ochiq"}
        />
        <Stat
          icon={<ServerCog />}
          label="Sog‘lom ma’lumot oqimi"
          value={market?.summary.healthy}
        />
        <Stat
          icon={<AlertTriangle />}
          label="Sustlashgan / ishlamayapti"
          value={(market?.summary.degraded ?? 0) + (market?.summary.down ?? 0)}
        />
        <Stat
          icon={<Grid3X3 />}
          label="Skaner kataklari"
          value={scanner?.items.length}
        />
      </section>
      <section className="admin-card">
        <div className="card-heading">
          <div>
            <h2>Global skaner xaritasi</h2>
            <p>Savdo holati kuchi: 0–100. Holat matn bilan ham ko‘rsatiladi.</p>
          </div>
        </div>
        <div className="admin-heatmap">
          <div />
          <>
            {tfs.map((tf) => (
              <b key={tf}>{tf}</b>
            ))}
          </>
          {symbols.flatMap((symbol) => [
            <strong key={`${symbol}:label`}>{symbol}</strong>,
            ...tfs.map((tf) => {
              const x = cells.get(`${symbol}:${tf}`);
              return (
                <div
                  key={`${symbol}:${tf}`}
                  className={`heat-cell ${x?.status ?? "empty"}`}
                  title={x?.errorCode ?? x?.marketRegime ?? ""}
                >
                  <span>
                    {x?.status === "no_setup"
                      ? "—"
                      : x?.status
                        ? statusNameUz(x.status)
                        : "—"}
                  </span>
                  <b>{x?.setupStrength ?? 0}</b>
                  <small>{x?.direction ?? ""}</small>
                </div>
              );
            }),
          ])}
        </div>
      </section>
      <div className="admin-two-col">
        <section className="admin-card">
          <div className="card-heading">
            <div>
              <h2>Provayder telemetriyasi</h2>
              <p>Kechikish, yetishmagan shamlar va avtomatik himoya</p>
            </div>
          </div>
          <div className="ops-table">
            <div className="ops-table-head">
              <span>Ma’lumot oqimi</span>
              <span>Holat</span>
              <span>Kechikish</span>
              <span>Yetishmagan shamlar</span>
            </div>
            {market?.rows.slice(0, 30).map((x) => (
              <div key={`${x.provider}:${x.symbol}:${x.timeframe}`}>
                <strong>
                  {x.symbol} · {x.timeframe}
                  <small>
                    {providerNameUz(x.provider)} · sham{" "}
                    {x.lastCandleAt
                      ? new Date(x.lastCandleAt).toLocaleString()
                      : "—"}
                  </small>
                </strong>
                <span className={`op-badge ${x.status}`}>
                  {statusNameUz(x.status)}
                </span>
                <span>{x.latencyMs ?? "—"} ms</span>
                <span>
                  {x.missingCandles}
                  {x.circuitOpenUntil &&
                  x.circuitOpenUntil > new Date().toISOString() ? (
                    <small className="danger-text">AVTOMATIK HIMOYA FAOL</small>
                  ) : null}
                </span>
              </div>
            ))}
          </div>
        </section>
        <section className="admin-card">
          <div className="card-heading">
            <div>
              <h2>Strategiya bosqichlari · 30 kun</h2>
              <p>Skanerlandi → holat topildi → signal → natija</p>
            </div>
          </div>
          <div className="funnel-list">
            {scanner?.funnel.map((x) => (
              <article key={x.code}>
                <strong>{strategyNameUz(x.code)}</strong>
                <div>
                  <span
                    style={{
                      width: `${x.scanned ? Math.max(3, (x.setups / x.scanned) * 100) : 0}%`,
                    }}
                  />
                </div>
                <dl>
                  <dt>Skanerlangan</dt>
                  <dd>{x.scanned}</dd>
                  <dt>Holat topildi</dt>
                  <dd>{x.setups}</dd>
                  <dt>Signal</dt>
                  <dd>{x.signals}</dd>
                  <dt>Natija</dt>
                  <dd>{x.results}</dd>
                </dl>
              </article>
            ))}
          </div>
        </section>
      </div>
      <div className="admin-two-col">
        <section className="admin-card">
          <div className="card-heading">
            <h2>Ommabop aktivlar</h2>
          </div>
          {scanner?.popularAssets.slice(0, 10).map((x) => (
            <div className="rank-row" key={`${x.symbol}:${x.timeframe}`}>
              <strong>
                {x.symbol} · {x.timeframe}
              </strong>
              <span>{x.followers} ta kuzatuv ro‘yxatida</span>
            </div>
          ))}
        </section>
        <section className="admin-card">
          <div className="card-heading">
            <h2>Ommabop strategiyalar</h2>
          </div>
          {scanner?.popularStrategies.slice(0, 10).map((x) => (
            <div className="rank-row" key={x.code}>
              <strong>{strategyNameUz(x.code)}</strong>
              <span>{x.followers} foydalanuvchi</span>
            </div>
          ))}
        </section>
      </div>
    </>
  );
}

function ReferralsView() {
  const [data, setData] = useState<AdminReferrals | null>(null),
    [error, setError] = useState("");
  const load = () =>
    void getAdminReferrals()
      .then(setData)
      .catch((e: unknown) =>
        setError(e instanceof Error ? e.message : "Xatolik yuz berdi"),
      );
  useEffect(load, []);
  const change = (id: string, status: "qualified" | "rejected") => {
    const reason =
      status === "rejected"
        ? window.prompt("Fraud yoki rad etish sababi:")?.trim() ||
          "Admin tekshiruvi"
        : null;
    void updateAdminReferral(id, status, reason)
      .then(load)
      .catch((e: unknown) =>
        setError(e instanceof Error ? e.message : "Xatolik yuz berdi"),
      );
  };
  return (
    <>
      <PageTitle
        eyebrow="O‘SISH VA FIRIBGARLIK NAZORATI"
        title="Tavsiya nazorati"
        subtitle="Konversiya, bonus tahlillar va shubhali takliflarni boshqarish."
        action={
          <button className="secondary" onClick={load}>
            <RefreshCw size={16} />
            Yangilash
          </button>
        }
      />
      {error && <p className="admin-error">{error}</p>}
      <section className="admin-stats">
        <Stat icon={<Users />} label="Jami" value={data?.summary.total} />
        <Stat
          icon={<UserCheck />}
          label="Tasdiqlangan"
          value={data?.summary.qualified}
        />
        <Stat
          icon={<Clock3 />}
          label="Kutilmoqda"
          value={data?.summary.pending}
        />
        <Stat
          icon={<Gift />}
          label="Konversiya"
          value={
            data?.summary.total
              ? `${Math.round((data.summary.qualified / data.summary.total) * 100)}% · +${data.summary.rewardedAnalyses}`
              : "0% · +0"
          }
        />
      </section>
      <section className="admin-card">
        <div className="card-heading">
          <div>
            <h2>Tavsiya oqimi</h2>
            <p>Har tasdiqlangan taklif bonusni faqat bir marta beradi.</p>
          </div>
        </div>
        <div className="referral-admin-list">
          {data?.items.map((x) => (
            <article key={x.id}>
              <div>
                <strong>
                  {x.referrerName ?? x.referrerUsername ?? "Foydalanuvchi"}{" "}
                  <span>→</span>{" "}
                  {x.referredName ?? x.referredUsername ?? "Foydalanuvchi"}
                </strong>
                <small>
                  {x.code} · {new Date(x.createdAt).toLocaleString()}
                </small>
                {x.fraudReason && <em>{x.fraudReason}</em>}
              </div>
              <b className={`op-badge ${x.status}`}>{statusNameUz(x.status)}</b>
              {x.status === "pending" && (
                <div className="row-actions">
                  <button
                    className="secondary"
                    onClick={() => change(x.id, "rejected")}
                  >
                    <Ban size={15} />
                    Rad etish
                  </button>
                  <button
                    className="primary"
                    onClick={() => change(x.id, "qualified")}
                  >
                    <Check size={15} />
                    Tasdiqlash
                  </button>
                </div>
              )}
            </article>
          ))}
        </div>
      </section>
    </>
  );
}

function SupportOpsView() {
  const [items, setItems] = useState<AdminSupportTicket[]>([]),
    [selected, setSelected] = useState<AdminSupportDetail | null>(null),
    [templates, setTemplates] = useState<SupportTemplate[]>([]),
    [reply, setReply] = useState(""),
    [error, setError] = useState("");
  const load = () =>
    void Promise.all([getAdminSupportTickets(), getSupportTemplates()])
      .then(([t, p]) => {
        setItems(t);
        setTemplates(p);
      })
      .catch((e: unknown) =>
        setError(e instanceof Error ? e.message : "Xatolik yuz berdi"),
      );
  useEffect(load, []);
  const open = (id: string) =>
    void getAdminSupportTicket(id)
      .then(setSelected)
      .catch((e: unknown) =>
        setError(e instanceof Error ? e.message : "Xatolik yuz berdi"),
      );
  const update = () => {
    if (!selected) return;
    void updateAdminSupportTicket(
      selected.id,
      selected.status,
      selected.priority,
    )
      .then(() => getAdminSupportTicket(selected.id))
      .then(setSelected)
      .then(load);
  };
  const send = () => {
    if (!selected || reply.trim().length < 2) return;
    void replyAdminSupportTicket(selected.id, reply.trim())
      .then(() => {
        setReply("");
        return getAdminSupportTicket(selected.id);
      })
      .then(setSelected)
      .then(load);
  };
  const openCount = items.filter(
    (x) => !["resolved", "closed"].includes(x.status),
  ).length;
  const overdue = items.filter(
    (x) =>
      !["resolved", "closed"].includes(x.status) &&
      Date.now() - Date.parse(x.lastMessageAt) > 4 * 3600000,
  ).length;
  return (
    <>
      <PageTitle
        eyebrow="OPERATOR MUROJAATLARI"
        title="Yordam markazi"
        subtitle="Murojaatlar, to‘lov yordami, xizmat muddati va javob shablonlari."
        action={
          <button className="secondary" onClick={load}>
            <RefreshCw size={16} />
            Yangilash
          </button>
        }
      />
      {error && <p className="admin-error">{error}</p>}
      <section className="admin-stats">
        <Stat
          icon={<MessageSquare />}
          label="Ochiq murojaat"
          value={openCount}
        />
        <Stat icon={<Clock3 />} label="SLA > 4 soat" value={overdue} />
        <Stat
          icon={<CircleDollarSign />}
          label="To‘lov"
          value={items.filter((x) => x.category === "payment").length}
        />
        <Stat
          icon={<FileCheck2 />}
          label="Hal qilingan"
          value={items.filter((x) => x.status === "resolved").length}
        />
      </section>
      <div className="support-console">
        <section className="admin-card support-inbox">
          <div className="card-heading">
            <h2>Operator murojaatlari</h2>
          </div>
          {items.map((x) => (
            <button
              className={selected?.id === x.id ? "active" : ""}
              key={x.id}
              onClick={() => open(x.id)}
            >
              <span className={`priority-dot ${x.priority}`} />
              <div>
                <strong>{x.subject}</strong>
                <small>
                  {x.firstName ?? x.username ?? x.telegramId} ·{" "}
                  {categoryNameUz(x.category)}
                </small>
                <p>{x.lastMessage}</p>
              </div>
              <b className={`op-badge ${x.status}`}>{statusNameUz(x.status)}</b>
            </button>
          ))}
        </section>
        <section className="admin-card ticket-workspace">
          {!selected ? (
            <div className="empty-admin">
              <Headphones />
              <h2>Murojaatni tanlang</h2>
              <p>Chap tomondagi ro‘yxatdan murojaatni oching.</p>
            </div>
          ) : (
            <>
              <div className="card-heading">
                <div>
                  <h2>{selected.subject}</h2>
                  <p>
                    {selected.firstName ?? selected.username} ·{" "}
                    {selected.telegramId}
                  </p>
                </div>
              </div>
              <div className="ticket-controls">
                <select
                  value={selected.status}
                  onChange={(e) =>
                    setSelected({
                      ...selected,
                      status: e.target.value as AdminSupportTicket["status"],
                    })
                  }
                >
                  {[
                    "open",
                    "in_progress",
                    "waiting_user",
                    "resolved",
                    "closed",
                  ].map((x) => (
                    <option key={x} value={x}>
                      {statusNameUz(x)}
                    </option>
                  ))}
                </select>
                <select
                  value={selected.priority}
                  onChange={(e) =>
                    setSelected({
                      ...selected,
                      priority: e.target
                        .value as AdminSupportTicket["priority"],
                    })
                  }
                >
                  {["low", "normal", "high", "urgent"].map((x) => (
                    <option key={x} value={x}>
                      {priorityNameUz(x)}
                    </option>
                  ))}
                </select>
                <button className="secondary" onClick={update}>
                  Saqlash
                </button>
              </div>
              <div className="admin-message-thread">
                {selected.messages.map((m) => (
                  <article className={m.senderType} key={m.id}>
                    <b>
                      {m.senderType === "admin" ? "Operator" : "Foydalanuvchi"}
                    </b>
                    <p>{m.body}</p>
                    <time>{new Date(m.createdAt).toLocaleString()}</time>
                  </article>
                ))}
              </div>
              <div className="template-chips">
                {templates
                  .filter(
                    (x) =>
                      x.category === selected.category ||
                      x.category === "general",
                  )
                  .map((t) => (
                    <button key={t.id} onClick={() => setReply(t.bodyUz)}>
                      {t.title}
                    </button>
                  ))}
              </div>
              <div className="admin-reply">
                <textarea
                  rows={4}
                  value={reply}
                  onChange={(e) => setReply(e.target.value)}
                  placeholder="UZ yoki RU javob…"
                />
                <button className="primary" onClick={send}>
                  <Send size={16} />
                  Javob yuborish
                </button>
              </div>
            </>
          )}
        </section>
      </div>
    </>
  );
}

function safeArray(value: string) {
  try {
    return JSON.parse(value) as string[];
  } catch {
    return [];
  }
}
